export enum MEDIA_TYPE {
  ALL = "ALL",
  PDF = "PDF",
  VIDEO = "VIDEO",
  NEW_PAGE = "NEW_PAGE",
}

export enum CATEGORIES {
  REPORTS = "REPORTS",
  NEWSLETTER = "NEWSLETTER",
  PUBLICATIONS = "PUBLICATIONS",
  COURSES = "COURSES",
  ADVERTORIALS = "ADVERTORIALS",
}

export enum LANGUAGE {
  EN = "EN",
  CH = "CH",
}
export enum ADVERTORIALS_SECTOR {
  OVERVIEW = "OVERVIEW",
  MAINLAND_OPPORTUNITY = "MAINLAND_OPPORTUNITY",
  MANPOWER = "MANPOWER",
  METROLOGY = "METROLOGY",
  TC_SUPPORT = "TC_SUPPORT",
  MANAGEMENT_SYSTEM = "MANAGEMENT_SYSTEM",
  CHINESE_MEDICINE = "CHINESE_MEDICINE",
  CONSTRUCTION = "CONSTRUCTION",
  ELECTRICAL_PRODUCTS = "ELECTRICAL_PRODUCTS",
  ENVIRONMENT_PROTECTION = "ENVIRONMENT_PROTECTION",
  FOOD = "FOOD",
  INFORMATION_TECHNOLOGY = "INFORMATION_TECHNOLOGY",
  JEWELLERY = "JEWELLERY",
  MEDICAL_TESTING = "MEDICAL_TESTING",
  TEXTILE_CLOTHING = "TEXTILE_CLOTHING",
  TOYS = "TOYS",
}

export type PublicationType = {
  title: string;
  titleCN?: string;
  date?: string;
  dateCN?: string;
  link: string;
  scLink?: string;
  tcLink?: string;
  sector?: ADVERTORIALS_SECTOR[];
  mediaType: MEDIA_TYPE;
  yearRange?: number[];
  category: CATEGORIES[];
  thumbnail?: string;
  mediaDomain?: "hkctc" | "youtube" | "cpas-icac" | "hkbedc";
  language?: LANGUAGE;
};

export type CoursesType = Omit<PublicationType, "date" | "mediaType"> & {
  language: LANGUAGE;
};

// Reports

export const hktctReportsList: PublicationType[] = [
  {
    title: "HKCTC Report 2023-24",
    date: "",
    titleCN: `2023-2024年度香港檢測和認證局報告`,
    link: "/en/doc/HKCTCAnnualReport_2023-24.pdf",
    mediaType: MEDIA_TYPE.PDF,
    yearRange: [2023, 2024],
    category: [CATEGORIES.REPORTS],
  },
  {
    title: "Report Highlights 2023-24",
    titleCN: `2023-2024年度報告摘要`,
    date: "",
    link: "/videos/en/hkctc_report_2023-24_highlights_en.mp4",
    mediaType: MEDIA_TYPE.VIDEO,
    yearRange: [2023, 2024],
    category: [CATEGORIES.REPORTS],
  },
  {
    title: "HKCTC Report 22-23",
    titleCN: `2022-2023年度香港檢測和認證局報告`,
    date: "",
    link: "/en/doc/HKCTCAnnualReport_2022-23.pdf",
    mediaType: MEDIA_TYPE.PDF,
    yearRange: [2022, 2023],
    category: [CATEGORIES.REPORTS],
  },
  {
    title: "Report Highlights 22-23",
    date: "",
    titleCN: `2022-2023年度報告摘要`,
    link: "/videos/en/hkctc_report_2022-23_highlights.mp4",
    mediaType: MEDIA_TYPE.VIDEO,
    yearRange: [2022, 2023],
    category: [CATEGORIES.REPORTS],
  },
  {
    title: "HKCTC Report 21-22",
    titleCN: `2021-2022年度香港檢測和認證局報告`,
    date: "",
    link: "/en/doc/HKCTCAnnualReport_2021-22_Eng.pdf",
    tcLink: "/tc/doc/HKCTCAnnualReport_2021-22_Chi.pdf",
    mediaType: MEDIA_TYPE.PDF,
    yearRange: [2021, 2022],
    category: [CATEGORIES.REPORTS],
  },
  {
    title: "HKCTC Report 20-21",
    date: "",
    titleCN: `2020-2021年度香港檢測和認證局報告`,
    link: "/en/doc/HKCTCAnnualReport_2020-21_Eng.pdf",
    tcLink: "/tc/doc/HKCTCAnnualReport_2020-21_Chi.pdf",
    mediaType: MEDIA_TYPE.PDF,
    yearRange: [2020, 2021],
    category: [CATEGORIES.REPORTS],
  },
  {
    title: "HKCTC Report 19-20",
    date: "",
    titleCN: `2019-2020年度香港檢測和認證局報告`,
    link: "/en/doc/HKCTCAnnualReport_2019-20_Eng.pdf",
    tcLink: "/tc/doc/HKCTCAnnualReport_2019-20_Chi.pdf",
    mediaType: MEDIA_TYPE.PDF,
    yearRange: [2019, 2020],
    category: [CATEGORIES.REPORTS],
  },
  {
    title: "HKCTC Report 18-19",
    titleCN: `2018-2019年度香港檢測和認證局報告`,
    date: "",
    link: "/en/doc/HKCTCAnnualReport_2018-19_Eng.pdf",
    tcLink: "/tc/doc/HKCTCAnnualReport_2018-19_Chi.pdf",
    mediaType: MEDIA_TYPE.PDF,
    yearRange: [2018, 2019],
    category: [CATEGORIES.REPORTS],
  },
  {
    title: "HKCTC Report 17-18",
    titleCN: `2017-2018年度香港檢測和認證局報告`,
    date: "",
    link: "/en/doc/HKCTCAnnualReport_2017-18_Eng.pdf",
    tcLink: "/tc/doc/HKCTCAnnualReport_2017-18_Chi.pdf",
    mediaType: MEDIA_TYPE.PDF,
    yearRange: [2017, 2018],
    category: [CATEGORIES.REPORTS],
  },
  {
    title: "HKCTC Report 16-17",
    titleCN: "2016-2017年度香港檢測和認證局報告",
    date: "",
    link: "/en/doc/HKCTCAnnualReport_2016-17_Eng.pdf",
    tcLink: "/tc/doc/HKCTCAnnualReport_2016-17_Chi.pdf",
    mediaType: MEDIA_TYPE.PDF,
    yearRange: [2016, 2017],
    category: [CATEGORIES.REPORTS],
  },
  {
    title: "HKCTC Report 15-16",
    date: "",
    titleCN: "2015-2016年度香港檢測和認證局報告",
    link: "/en/doc/HKCTCAnnualReport_2015-16_Eng.pdf",
    tcLink: "/tc/doc/HKCTCAnnualReport_2015-16_Chi.pdf",
    mediaType: MEDIA_TYPE.PDF,
    yearRange: [2015, 2016],
    category: [CATEGORIES.REPORTS],
  },
  {
    title: "HKCTC Report 14-15",
    titleCN: "2014-2015年度香港檢測和認證局報告",
    date: "",
    link: "/en/doc/HKCTCAnnualReport_2014-15_Eng.pdf",
    tcLink: "/tc/doc/HKCTCAnnualReport_2014-15_Chi.pdf",
    mediaType: MEDIA_TYPE.PDF,
    yearRange: [2014, 2015],
    category: [CATEGORIES.REPORTS],
  },
  {
    title: "HKCTC Report 13-14",
    titleCN: "2013-2014年度香港檢測和認證局報告",
    date: "",
    link: "/en/doc/HKCTCAnnualReport_2013-14_Eng_F.pdf",
    tcLink: "/tc/doc/HKCTCAnnualReport_2013-14_Chi_F.pdf",
    mediaType: MEDIA_TYPE.PDF,
    yearRange: [2013, 2014],
    category: [CATEGORIES.REPORTS],
  },
  {
    title: "Report Review 13-14",
    date: "",
    titleCN: "2013年香港檢測和認證局檢討報告",
    link: "/en/doc/HKCTC_Report_Eng(2013)LR.pdf",
    tcLink: "/tc/doc/HKCTC_Report_Chi(2013)LR.pdf",
    mediaType: MEDIA_TYPE.PDF,
    yearRange: [2013, 2014],
    category: [CATEGORIES.REPORTS],
  },
  {
    title: "HKCTC Report 11-12",
    date: "",
    titleCN: "2011-2012年度香港檢測和認證局報告",
    link: "/en/doc/HKCTC_annual_report_2011-12_e_final2.pdf",
    tcLink: "/tc/doc/HKCTC_annual_report_2011-12_c_final2.pdf",
    mediaType: MEDIA_TYPE.PDF,
    yearRange: [2011, 2012],
    category: [CATEGORIES.REPORTS],
  },
  {
    title: "HKCTC Report 10-11",
    date: "",
    titleCN: "2010-2011年度香港檢測和認證局報告",
    link: "/en/doc/HKCTC_Report_2010-11_Eng.pdf",
    tcLink: "/tc/doc/HKCTC_Report_2010-11_Chi.pdf",
    mediaType: MEDIA_TYPE.PDF,
    yearRange: [2010, 2011],
    category: [CATEGORIES.REPORTS],
  },
  {
    title: "HKCTC Report",
    date: "",
    titleCN: "香港檢測和認證局報告",
    link: "/en/doc/HKCTC_Report_Eng.pdf",
    tcLink: "/tc/doc/HKCTCAnnualReport_2018-19_Chi.pdf",
    mediaType: MEDIA_TYPE.PDF,
    yearRange: [2010, 2011],
    category: [CATEGORIES.REPORTS],
  },
];

export const hktctReportsList_cn: PublicationType[] = [
  {
    title: "2023-2024年度香港檢測和認證局報告",
    date: "",
    link: "/en/doc/HKCTCAnnualReport_2023-24.pdf",
    mediaType: MEDIA_TYPE.PDF,
    yearRange: [2023, 2024],
    category: [CATEGORIES.REPORTS],
  },
  {
    title: "2023-2024年度報告摘要",
    date: "",
    link: "/videos/en/hkctc_report_2023-24_highlights_en.mp4",
    mediaType: MEDIA_TYPE.VIDEO,
    yearRange: [2023, 2024],
    category: [CATEGORIES.REPORTS],
  },
  {
    title: "2022-2023年度香港檢測和認證局報告",
    date: "",
    link: "/en/doc/HKCTCAnnualReport_2022-23.pdf",
    mediaType: MEDIA_TYPE.PDF,
    yearRange: [2022, 2023],
    category: [CATEGORIES.REPORTS],
  },
  {
    title: "2022-2023年度報告摘要",
    date: "",
    link: "/videos/en/hkctc_report_2022-23_highlights.mp4",
    mediaType: MEDIA_TYPE.VIDEO,
    yearRange: [2022, 2023],
    category: [CATEGORIES.REPORTS],
  },
  {
    title: "2021-2022年度香港檢測和認證局報告",
    date: "",
    link: "/en/doc/HKCTCAnnualReport_2021-22_Eng.pdf",
    tcLink: "/tc/doc/HKCTCAnnualReport_2021-22_Chi.pdf",
    mediaType: MEDIA_TYPE.PDF,
    yearRange: [2021, 2022],
    category: [CATEGORIES.REPORTS],
  },
  {
    title: "2020-2021年度香港檢測和認證局報告",
    date: "",
    link: "/en/doc/HKCTCAnnualReport_2020-21_Eng.pdf",
    tcLink: "/tc/doc/HKCTCAnnualReport_2020-21_Chi.pdf",
    mediaType: MEDIA_TYPE.PDF,
    yearRange: [2020, 2021],
    category: [CATEGORIES.REPORTS],
  },
  {
    title: "2019-2020年度香港檢測和認證局報告",
    date: "",
    link: "/en/doc/HKCTCAnnualReport_2019-20_Eng.pdf",
    tcLink: "/tc/doc/HKCTCAnnualReport_2019-20_Chi.pdf",
    mediaType: MEDIA_TYPE.PDF,
    yearRange: [2019, 2020],
    category: [CATEGORIES.REPORTS],
  },
  {
    title: "2018-2019年度香港檢測和認證局報告",
    date: "",
    link: "/en/doc/HKCTCAnnualReport_2018-19_Eng.pdf",
    tcLink: "/tc/doc/HKCTCAnnualReport_2018-19_Chi.pdf",
    mediaType: MEDIA_TYPE.PDF,
    yearRange: [2018, 2019],
    category: [CATEGORIES.REPORTS],
  },
  {
    title: "2017-2018年度香港檢測和認證局報告",
    date: "",
    link: "/en/doc/HKCTCAnnualReport_2017-18_Eng.pdf",
    tcLink: "/tc/doc/HKCTCAnnualReport_2017-18_Chi.pdf",
    mediaType: MEDIA_TYPE.PDF,
    yearRange: [2017, 2018],
    category: [CATEGORIES.REPORTS],
  },
  {
    title: "2016-2017年度香港檢測和認證局報告",
    date: "",
    link: "/en/doc/HKCTCAnnualReport_2016-17_Eng.pdf",
    tcLink: "/tc/doc/HKCTCAnnualReport_2016-17_Chi.pdf",
    mediaType: MEDIA_TYPE.PDF,
    yearRange: [2016, 2017],
    category: [CATEGORIES.REPORTS],
  },
  {
    title: "2015-2016年度香港檢測和認證局報告",
    date: "",
    link: "/en/doc/HKCTCAnnualReport_2015-16_Eng.pdf",
    tcLink: "/tc/doc/HKCTCAnnualReport_2015-16_Chi.pdf",
    mediaType: MEDIA_TYPE.PDF,
    yearRange: [2015, 2016],
    category: [CATEGORIES.REPORTS],
  },
  {
    title: "2014-2015年度香港檢測和認證局報告",
    date: "",
    link: "/en/doc/HKCTCAnnualReport_2014-15_Eng.pdf",
    tcLink: "/tc/doc/HKCTCAnnualReport_2014-15_Chi.pdf",
    mediaType: MEDIA_TYPE.PDF,
    yearRange: [2014, 2015],
    category: [CATEGORIES.REPORTS],
  },
  {
    title: "2013-2014年度香港檢測和認證局報告",
    date: "",
    link: "/en/doc/HKCTCAnnualReport_2013-14_Eng_F.pdf",
    tcLink: "/tc/doc/HKCTCAnnualReport_2013-14_Chi_F.pdf",
    mediaType: MEDIA_TYPE.PDF,
    yearRange: [2013, 2014],
    category: [CATEGORIES.REPORTS],
  },
  {
    title: "2013年香港檢測和認證局檢討報告",
    date: "",
    link: "/en/doc/HKCTC_Report_Eng(2013)LR.pdf",
    tcLink: "/tc/doc/HKCTC_Report_Chi(2013)LR.pdf",
    mediaType: MEDIA_TYPE.PDF,
    yearRange: [2013, 2014],
    category: [CATEGORIES.REPORTS],
  },
  {
    title: "2011-2012年度香港檢測和認證局報告",
    date: "",
    link: "/en/doc/HKCTC_annual_report_2011-12_e_final2.pdf",
    tcLink: "/tc/doc/HKCTC_annual_report_2011-12_c_final2.pdf",
    mediaType: MEDIA_TYPE.PDF,
    yearRange: [2011, 2012],
    category: [CATEGORIES.REPORTS],
  },
  {
    title: "2010-2011年度香港檢測和認證局報告",
    date: "",
    link: "/en/doc/HKCTC_Report_2010-11_Eng.pdf",
    tcLink: "/tc/doc/HKCTC_Report_2010-11_Chi.pdf",
    mediaType: MEDIA_TYPE.PDF,
    yearRange: [2010, 2011],
    category: [CATEGORIES.REPORTS],
  },
  {
    title: "香港檢測和認證局報告",
    date: "",
    link: "/en/doc/HKCTC_Report_Eng.pdf",
    tcLink: "/tc/doc/HKCTCAnnualReport_2018-19_Chi.pdf",
    mediaType: MEDIA_TYPE.PDF,
    yearRange: [2010, 2011],
    category: [CATEGORIES.REPORTS],
  },
];

export const legislativeCouncilList: PublicationType[] = [
  {
    title: "Latest Development of the T&C Industry 2023",
    date: "27 Jun 2023",
    titleCN: "檢測和認證業的最新發展",
    dateCN: "2023年6月27日",
    link: "/en/doc/ci20230620cb1-661-3-e.pdf",
    tcLink: "/tc/doc/ci20230620cb1-661-3-c.pdf",
    mediaType: MEDIA_TYPE.PDF,
    yearRange: [2023, 2023],
    category: [CATEGORIES.REPORTS],
  },
  {
    title: "Latest Development of the T&C Industry 2021",
    date: "19 Feb 2021",
    titleCN: "檢測和認證業的最新發展",
    dateCN: "2021年2月19日",
    link: "/en/doc/CIPanel_20210219_Paper_Eng.pdf",
    tcLink: "/tc/doc/CIPanel_20210219_Paper_Chi.pdf",
    mediaType: MEDIA_TYPE.PDF,
    yearRange: [2021, 2021],
    category: [CATEGORIES.REPORTS],
  },

  {
    title: "Latest Development of the T&C Industry 2018",
    date: "27 Feb 2018",
    titleCN: "檢測和認證業的最新發展",
    dateCN: "2018年2月27日",
    link: "/en/doc/AdministrationPaper_ci20180227cb1-604-3-e.pdf",
    tcLink: "/tc/doc/AdministrationPaper_ci20180227cb1-604-3-c.pdf",
    mediaType: MEDIA_TYPE.PDF,
    yearRange: [2018, 2018],
    category: [CATEGORIES.REPORTS],
  },
  {
    title: "Latest Development of the T&C Industry 2015",
    date: "17 Nov 2015",
    titleCN: "檢測和認證業的最新發展",
    dateCN: "2015年11月17日",
    link: "/en/doc/ci20151117cb1-148-3-e.pdf",
    tcLink: "/tc/doc/ci20151117cb1-148-3-c.pdf",
    mediaType: MEDIA_TYPE.PDF,
    yearRange: [2015, 2015],
    category: [CATEGORIES.REPORTS],
  },
  {
    title:
      "Measures to Regularise and Facilitate the Operation of Testing Laboratories in Industrial Buildings",
    date: "23 Apr 2015",
    titleCN: "有助規範和促進測試實驗所於工業大廈營運的措施",
    dateCN: "2015年4月23日",
    link: "/en/doc/itc-hkctc-17-7-1c-e.pdf",
    tcLink: "/tc/doc/itc-hkctc-17-7-1c-c.pdf",
    mediaType: MEDIA_TYPE.PDF,
    yearRange: [2015, 2015],
    category: [CATEGORIES.REPORTS],
  },
];

export const legislativeCouncilList_cn: PublicationType[] = [
  {
    title: "檢測和認證業的最新發展",
    date: "2023年6月27日",
    link: "/en/doc/ci20230620cb1-661-3-e.pdf",
    tcLink: "/tc/doc/ci20230620cb1-661-3-c.pdf",
    mediaType: MEDIA_TYPE.PDF,
    yearRange: [2023, 2023],
    category: [CATEGORIES.REPORTS],
  },
  {
    title: "檢測和認證業的最新發展",
    date: "2021年2月19日",
    link: "/en/doc/CIPanel_20210219_Paper_Eng.pdf",
    tcLink: "/tc/doc/CIPanel_20210219_Paper_Chi.pdf",
    mediaType: MEDIA_TYPE.PDF,
    yearRange: [2021, 2021],
    category: [CATEGORIES.REPORTS],
  },
  {
    title: "檢測和認證業的最新發展",
    date: "2018年2月27日",
    link: "/en/doc/AdministrationPaper_ci20180227cb1-604-3-e.pdf",
    tcLink: "/tc/doc/AdministrationPaper_ci20180227cb1-604-3-c.pdf",
    mediaType: MEDIA_TYPE.PDF,
    yearRange: [2018, 2018],
    category: [CATEGORIES.REPORTS],
  },
  {
    title: "檢測和認證業的最新發展",
    date: "2015年11月17日",
    link: "/en/doc/ci20151117cb1-148-3-e.pdf",
    tcLink: "/tc/doc/ci20151117cb1-148-3-c.pdf",
    mediaType: MEDIA_TYPE.PDF,
    yearRange: [2015, 2015],
    category: [CATEGORIES.REPORTS],
  },
  {
    title: "有助規範和促進測試實驗所於工業大廈營運的措施",
    date: "2015年4月23日",
    link: "/en/doc/itc-hkctc-17-7-1c-e.pdf",
    tcLink: "/tc/doc/itc-hkctc-17-7-1c-c.pdf",
    mediaType: MEDIA_TYPE.PDF,
    yearRange: [2015, 2015],
    category: [CATEGORIES.REPORTS],
  },
];

export const hkctcNewsletterList: PublicationType[] = [
  {
    title: "No. 12 (Dec 2024)",
    titleCN: "第十二期（2024年12月）",
    date: "",
    link: "/tc/doc/hkctc_newsletter_issue12.pdf",
    mediaType: MEDIA_TYPE.PDF,
    yearRange: [2024, 2025],
    category: [CATEGORIES.NEWSLETTER, CATEGORIES.PUBLICATIONS],
  },
  {
    title: "No. 11 (May 2024)",
    date: "",
    titleCN: "第十一期（2024年5月）",
    link: "/tc/doc/hkctc_newsletter_issue11.pdf",
    mediaType: MEDIA_TYPE.PDF,
    yearRange: [2023, 2023],
    category: [CATEGORIES.NEWSLETTER, CATEGORIES.PUBLICATIONS],
  },
  {
    title: "No. 10 (Dec 2023)",
    date: "",
    titleCN: "第十期（2023年12月）",
    link: "/tc/doc/hkctc_newsletter_issue10.pdf",
    mediaType: MEDIA_TYPE.PDF,
    yearRange: [2023, 2023],
    category: [CATEGORIES.NEWSLETTER, CATEGORIES.PUBLICATIONS],
  },
  {
    title: "No. 9 (May 2023)",
    date: "",
    titleCN: "第九期（2023年5月）",
    link: "/tc/doc/hkctc_newsletter_issue9.pdf",
    mediaType: MEDIA_TYPE.PDF,
    yearRange: [2023, 2023],
    category: [CATEGORIES.NEWSLETTER, CATEGORIES.PUBLICATIONS],
  },
  {
    title: "No. 8 (Aug 2022)",
    date: "",
    titleCN: "第八期（2022年8月）",
    link: "/tc/doc/hkctc_newsletter_issue8.pdf",
    mediaType: MEDIA_TYPE.PDF,
    yearRange: [2022, 2022],
    category: [CATEGORIES.NEWSLETTER, CATEGORIES.PUBLICATIONS],
  },
  {
    title: "No. 7 (Jul 2021)",
    date: "",
    titleCN: "第七期（2021年7月）",
    link: "/tc/doc/hkctc_newsletter_issue7.pdf",
    mediaType: MEDIA_TYPE.PDF,
    yearRange: [2021, 2021],
    category: [CATEGORIES.NEWSLETTER, CATEGORIES.PUBLICATIONS],
  },
  {
    title: "No. 6 (Dec 2020)",
    date: "",
    titleCN: "第六期（2020年12月）",
    link: "/tc/doc/hkctc_newsletter_issue6.pdf",
    mediaType: MEDIA_TYPE.PDF,
    yearRange: [2020, 2020],
    category: [CATEGORIES.NEWSLETTER, CATEGORIES.PUBLICATIONS],
  },
  {
    title: "No. 5 (Jan 2020)",
    titleCN: "第五期（2020年1月）",
    date: "",
    link: "/tc/doc/hkctc_newsletter_issue5.pdf",
    mediaType: MEDIA_TYPE.PDF,
    yearRange: [2020, 2020],
    category: [CATEGORIES.NEWSLETTER, CATEGORIES.PUBLICATIONS],
  },
  {
    title: "No. 4 (Jul 2019)",
    titleCN: "第四期（2019年7月)",
    date: "",
    link: "/tc/doc/hkctc_newsletter_issue4.pdf",
    mediaType: MEDIA_TYPE.PDF,
    yearRange: [2019, 2019],
    category: [CATEGORIES.NEWSLETTER, CATEGORIES.PUBLICATIONS],
  },
  {
    title: "No. 3 (Oct 2018)",
    titleCN: "第三期（2018年10月）",
    date: "",
    link: "/tc/doc/hkctc_newsletter_issue3.pdf",
    mediaType: MEDIA_TYPE.PDF,
    yearRange: [2018, 2018],
    category: [CATEGORIES.NEWSLETTER, CATEGORIES.PUBLICATIONS],
  },
  {
    title: "No. 2 (Dec 2017)",
    titleCN: "第二期（2017年12月)",
    date: "",
    link: "/tc/doc/hkctc_newsletter_issue2.pdf",
    mediaType: MEDIA_TYPE.PDF,
    yearRange: [2017, 2017],
    category: [CATEGORIES.NEWSLETTER, CATEGORIES.PUBLICATIONS],
  },
  {
    title: "No. 1 (Jul 2017)",
    titleCN: "第一期（2017年7月）",
    date: "",
    link: "/tc/doc/hkctc_newsletter_issue1.pdf",
    mediaType: MEDIA_TYPE.PDF,
    yearRange: [2017, 2017],
    category: [CATEGORIES.NEWSLETTER, CATEGORIES.PUBLICATIONS],
  },
];

export const hkctcNewsletterList_cn: PublicationType[] =
  hkctcNewsletterList.map((item) => {
    return {
      ...item,
      title: item.titleCN as string,
    };
  });

export const coursesList: CoursesType[] = [
  {
    title:
      "Analysis of Colorants in Food and Personal-Care Products (English Version)",
    link: "/videos/en/STEM_Module_1_Eng.mp4", // https://www.hkctc.gov.hk
    category: [CATEGORIES.COURSES],
    language: LANGUAGE.EN,
  },

  {
    title:
      "Analysis of Colorants in Food and Personal-Care Products (Cantonese Version)",
    link: "/videos/tc/STEM_Module_1_Chi.mp4",
    category: [CATEGORIES.COURSES],
    language: LANGUAGE.CH,
  },
  {
    title:
      "Screening Test for Plastic Type of Plastic Products (English Version)",
    link: "/videos/en/STEM_Module_2_Eng.mp4",
    category: [CATEGORIES.COURSES],
    language: LANGUAGE.EN,
  },
  {
    title:
      "Screening Test for Plastic Type of Plastic Products (Cantonese Version)",
    link: "/videos/tc/STEM_Module_2_Chi.mp4",
    category: [CATEGORIES.COURSES],
    language: LANGUAGE.CH,
  },

  {
    title: "Analysis of Bacteria in Environmental Samples (English Version)",
    link: "/videos/en/STEM_Module_3_Eng.mp4",
    category: [CATEGORIES.COURSES],
    language: LANGUAGE.EN,
  },
  {
    title: "Analysis of Bacteria in Environmental Samples (Cantonese Version)",
    link: "/videos/tc/STEM_Module_3_Chi.mp4",
    category: [CATEGORIES.COURSES],
    language: LANGUAGE.CH,
  },

  {
    title: "Wine-Making and Analysis of Alcohol in Beverage (English Version)",
    link: "/videos/en/STEM_Module_4_Eng.mp4",
    category: [CATEGORIES.COURSES],
    language: LANGUAGE.EN,
  },
  {
    title:
      "Wine-Making and Analysis of Alcohol in Beverage (Cantonese Version)",
    link: "/videos/tc/STEM_Module_4_Chi.mp4",
    category: [CATEGORIES.COURSES],
    language: LANGUAGE.CH,
  },

  {
    title: "Slime-Making and Analysis of Borax in Slime (English Version)",
    link: "/videos/en/STEM_Module_5_Eng.mp4",
    category: [CATEGORIES.COURSES],
    language: LANGUAGE.EN,
  },
  {
    title: "Slime-Making and Analysis of Borax in Slime (Cantonese Version)",
    link: "/videos/tc/STEM_Module_5_Chi.mp4",
    category: [CATEGORIES.COURSES],
    language: LANGUAGE.CH,
  },

  {
    title:
      "Solar Cell Fabrication and Testing on its Electrical Properties (English Version)",
    link: "/videos/en/STEM_Module_6_Eng.mp4",
    category: [CATEGORIES.COURSES],
    language: LANGUAGE.EN,
  },
  {
    title:
      "Solar Cell Fabrication and Testing on its Electrical Properties (Cantonese Version)",
    link: "/videos/tc/STEM_Module_6_Chi.mp4",
    category: [CATEGORIES.COURSES],
    language: LANGUAGE.CH,
  },

  {
    title:
      "Determination of NO2 in Air: Air Pollutant Analysis (English Version)",
    link: "/videos/en/chemistryhkbueduhkitcDemo-Ehtm_Exp01.mp4",
    category: [CATEGORIES.COURSES],
    language: LANGUAGE.EN,
  },
  {
    title:
      "Determination of NO2 in Air: Air Pollutant Analysis (Cantonese Version)",
    link: "/videos/tc/chemistryhkbueduhkitcDemo-Chtm_Exp01.mp4",
    category: [CATEGORIES.COURSES],
    language: LANGUAGE.CH,
  },

  {
    title: "Analysis of Copper in Wastewater (English Version)",
    link: "/videos/en/chemistryhkbueduhkitcDemo-Ehtm_Exp02.mp4",
    category: [CATEGORIES.COURSES],
    language: LANGUAGE.EN,
  },
  {
    title: "Analysis of Copper in Wastewater (Cantonese Version)",
    link: "/videos/tc/chemistryhkbueduhkitcDemo-Chtm_Exp02.mp4",
    category: [CATEGORIES.COURSES],
    language: LANGUAGE.CH,
  },

  {
    title:
      "Determination of SO2 in Dried Food Using Optimized Monier-Williams Method (English Version)",
    link: "/videos/en/chemistryhkbueduhkitcDemo-Ehtm_Exp03.mp4",
    category: [CATEGORIES.COURSES],
    language: LANGUAGE.EN,
  },
  {
    title:
      "Determination of SO2 in Dried Food Using Optimized Monier-Williams Method (Cantonese Version)",
    link: "/videos/tc/chemistryhkbueduhkitcDemo-Chtm_Exp03.mp4",
    category: [CATEGORIES.COURSES],
    language: LANGUAGE.CH,
  },

  {
    title:
      "Is the Dairy Product Safe? Gold Nanoparticles as a Visual Detection Tool of Melamine (English Version)",
    link: "/videos/en/chemistryhkbueduhkitcDemo-Ehtm_Exp04.mp4",
    category: [CATEGORIES.COURSES],
    language: LANGUAGE.EN,
  },
  {
    title:
      "Is the Dairy Product Safe? Gold Nanoparticles as a Visual Detection Tool of Melamine (Cantonese Version)",
    link: "/videos/tc/chemistryhkbueduhkitcDemo-Chtm_Exp04.mp4",
    category: [CATEGORIES.COURSES],
    language: LANGUAGE.CH,
  },

  {
    title:
      "Is the Dairy Product Safe? Gold Nanoparticles as a Visual Detection Tool of Melamine (English Version)",
    link: "/videos/en/chemistryhkbueduhkitcDemo-Ehtm_Exp04.mp4",
    category: [CATEGORIES.COURSES],
    language: LANGUAGE.EN,
  },
  {
    title:
      "Differentiation of Chinese Herb Danshen from Other Similar Herbs Using Facile Test-Tube Scale Chemical Test Method (English Version)",
    link: "/videos/en/chemistryhkbueduhkitcDemo-Ehtm_Exp05.mp4",
    category: [CATEGORIES.COURSES],
    language: LANGUAGE.CH,
  },
  {
    title:
      "Differentiation of Chinese Herb Danshen from Other Similar Herbs Using Facile Test-Tube Scale Chemical Test Method (Cantonese Version)",
    link: "/videos/tc/chemistryhkbueduhkitcDemo-Chtm_Exp05.mp4",
    category: [CATEGORIES.COURSES],
    language: LANGUAGE.CH,
  },

  {
    title:
      "Determination of Vitamin C in Commercial Sample and Fresh Fruit Juice by Iodometric Titration (English Version)",
    link: "/videos/en/chemistryhkbueduhkitcDemo-Ehtm_Exp06.mp4",
    category: [CATEGORIES.COURSES],
    language: LANGUAGE.CH,
  },
  {
    title:
      "Determination of Vitamin C in Commercial Sample and Fresh Fruit Juice by Iodometric Titration (Cantonese Version)",
    link: "/videos/tc/chemistryhkbueduhkitcDemo-Chtm_Exp06.mp4.mp4",
    category: [CATEGORIES.COURSES],
    language: LANGUAGE.CH,
  },
];

export const coursesList_cn: CoursesType[] = [
  {
    title: "食品和個人護理產品中的著色劑分析 (英文版本)",
    link: "/videos/en/STEM_Module_1_Eng.mp4",
    category: [CATEGORIES.COURSES],
    language: LANGUAGE.EN,
  },
  {
    title: "食品和個人護理產品中的著色劑分析 (粵語版本)",
    link: "/videos/tc/STEM_Module_1_Chi.mp4",
    category: [CATEGORIES.COURSES],
    language: LANGUAGE.CH,
  },
  {
    title: "塑料產品類型的篩選測試 (英文版本)",
    link: "/videos/en/STEM_Module_2_Eng.mp4",
    category: [CATEGORIES.COURSES],
    language: LANGUAGE.EN,
  },
  {
    title: "塑料產品類型的篩選測試 (粵語版本)",
    link: "/videos/tc/STEM_Module_2_Chi.mp4",
    category: [CATEGORIES.COURSES],
    language: LANGUAGE.CH,
  },
  {
    title: "環境樣品中的細菌分析 (英文版本)",
    link: "/videos/en/STEM_Module_3_Eng.mp4",
    category: [CATEGORIES.COURSES],
    language: LANGUAGE.EN,
  },
  {
    title: "環境樣品中的細菌分析 (粵語版本)",
    link: "/videos/tc/STEM_Module_3_Chi.mp4",
    category: [CATEGORIES.COURSES],
    language: LANGUAGE.CH,
  },
  {
    title: "釀酒與飲料中酒精的分析 (英文版本)",
    link: "/videos/en/STEM_Module_4_Eng.mp4",
    category: [CATEGORIES.COURSES],
    language: LANGUAGE.EN,
  },
  {
    title: "釀酒與飲料中酒精的分析 (粵語版本)",
    link: "/videos/tc/STEM_Module_4_Chi.mp4",
    category: [CATEGORIES.COURSES],
    language: LANGUAGE.CH,
  },
  {
    title: "「鬼口水」的製作和「鬼口水」中硼砂成份的分析 (英文版本)",
    link: "/videos/en/STEM_Module_5_Eng.mp4",
    category: [CATEGORIES.COURSES],
    language: LANGUAGE.EN,
  },
  {
    title: "「鬼口水」的製作和「鬼口水」中硼砂成份的分析 (粵語版本)",
    link: "/videos/tc/STEM_Module_5_Chi.mp4",
    category: [CATEGORIES.COURSES],
    language: LANGUAGE.CH,
  },
  {
    title: "太陽能電池的製造和電性能測試 (英文版本)",
    link: "/videos/en/STEM_Module_6_Eng.mp4",
    category: [CATEGORIES.COURSES],
    language: LANGUAGE.EN,
  },
  {
    title: "太陽能電池的製造和電性能測試 (粵語版本)",
    link: "/videos/tc/STEM_Module_6_Chi.mp4",
    category: [CATEGORIES.COURSES],
    language: LANGUAGE.CH,
  },
  {
    title: "空氣中二氧化氮的測試 (英文版本)",
    link: "/videos/en/chemistryhkbueduhkitcDemo-Ehtm_Exp01.mp4",
    category: [CATEGORIES.COURSES],
    language: LANGUAGE.EN,
  },
  {
    title: "空氣中二氧化氮的測試 (粵語版本)",
    link: "/videos/tc/chemistryhkbueduhkitcDemo-Chtm_Exp01.mp4",
    category: [CATEGORIES.COURSES],
    language: LANGUAGE.CH,
  },
  {
    title: "分析廢水的含銅量 (英文版本)",
    link: "/videos/en/chemistryhkbueduhkitcDemo-Ehtm_Exp02.mp4",
    category: [CATEGORIES.COURSES],
    language: LANGUAGE.EN,
  },
  {
    title: "分析廢水的含銅量 (粵語版本)",
    link: "/videos/tc/chemistryhkbueduhkitcDemo-Chtm_Exp02.mp4",
    category: [CATEGORIES.COURSES],
    language: LANGUAGE.CH,
  },
  {
    title: "以優化「莫尼—威廉」法測試乾糧中的二氧化硫含量 (英文版本)",
    link: "/videos/en/chemistryhkbueduhkitcDemo-Ehtm_Exp03.mp4",
    category: [CATEGORIES.COURSES],
    language: LANGUAGE.EN,
  },
  {
    title: "以優化「莫尼—威廉」法測試乾糧中的二氧化硫含量 (粵語版本)",
    link: "/videos/tc/chemistryhkbueduhkitcDemo-Chtm_Exp03.mp4",
    category: [CATEGORIES.COURSES],
    language: LANGUAGE.CH,
  },
  {
    title:
      "這乳製品安全嗎？使用金鈉米粒子「比色探針法」檢測三聚氰胺 (英文版本)",
    link: "/videos/en/chemistryhkbueduhkitcDemo-Ehtm_Exp04.mp4",
    category: [CATEGORIES.COURSES],
    language: LANGUAGE.EN,
  },
  {
    title:
      "這乳製品安全嗎？使用金鈉米粒子「比色探針法」檢測三聚氰胺 (粵語版本)",
    link: "/videos/tc/chemistryhkbueduhkitcDemo-Chtm_Exp04.mp4",
    category: [CATEGORIES.COURSES],
    language: LANGUAGE.CH,
  },
  {
    title:
      "這乳製品安全嗎？使用金鈉米粒子「比色探針法」檢測三聚氰胺 (英文版本)",
    link: "/videos/en/chemistryhkbueduhkitcDemo-Ehtm_Exp04.mp4",
    category: [CATEGORIES.COURSES],
    language: LANGUAGE.EN,
  },
  {
    title: "使用快速試管化學測試法分辨中國草藥丹參與其他類似的草藥 (英文版本)",
    link: "/videos/en/chemistryhkbueduhkitcDemo-Ehtm_Exp05.mp4",
    category: [CATEGORIES.COURSES],
    language: LANGUAGE.CH,
  },
  {
    title: "使用快速試管化學測試法分辨中國草藥丹參與其他類似的草藥 (粵語版本)",
    link: "/videos/tc/chemistryhkbueduhkitcDemo-Chtm_Exp05.mp4",
    category: [CATEGORIES.COURSES],
    language: LANGUAGE.CH,
  },
  {
    title: "以碘滴定法測試維他命商品和鮮榨果汁的維他命C含量 (英文版本)",
    link: "/videos/en/chemistryhkbueduhkitcDemo-Ehtm_Exp06.mp4",
    category: [CATEGORIES.COURSES],
    language: LANGUAGE.CH,
  },
  {
    title: "以碘滴定法測試維他命商品和鮮榨果汁的維他命C含量 (粵語版本)",
    link: "/videos/tc/chemistryhkbueduhkitcDemo-Chtm_Exp06.mp4.mp4",
    category: [CATEGORIES.COURSES],
    language: LANGUAGE.CH,
  },
];

export const convertedCoursesList: PublicationType[] = coursesList.map((c) => ({
  title: c.title,
  link: c.link,
  mediaType: MEDIA_TYPE.VIDEO,
  category: c.category,
  language: c.language,
}));

export const convertedCoursesList_cn: PublicationType[] = coursesList_cn.map(
  (c) => ({
    title: c.title,
    link: c.link,
    mediaType: MEDIA_TYPE.VIDEO,
    category: c.category,
    language: c.language,
  })
);

export const pamphletsList: PublicationType[] = [
  {
    title: "Tested in Hong Kong Certified in Hong Kong",
    titleCN: "香港檢測 香港認證",
    date: "",
    link: "/en/doc/Tested_in_Hong_Kong_Certified_in_Hong_Kong_en_tc.pdf",
    scLink: "/sc/doc/Tested_in_Hong_Kong_Certified_in_Hong_Kong_en_sc.pdf",
    tcLink: "/en/doc/Tested_in_Hong_Kong_Certified_in_Hong_Kong_en_tc.pdf",
    mediaType: MEDIA_TYPE.PDF,
    category: [CATEGORIES.PUBLICATIONS],
    thumbnail: "Tested_in_Hong_Kong_Certified_in_Hong_Kong_en_tc.png",
  },
  {
    title: "Product Certification - An Upstream Quality Control",
    date: "",
    titleCN: "產品認証 - 從上游監控品質",
    link: "/en/doc/HKCTC_Leaflet_construction_product_certification.pdf",
    scLink: "/en/doc/HKCTC_Leaflet_construction_product_certification.pdf",
    tcLink: "/en/doc/HKCTC_Leaflet_construction_product_certification.pdf",
    mediaType: MEDIA_TYPE.PDF,
    category: [CATEGORIES.PUBLICATIONS],
    thumbnail: "HKCTC_Leaflet_construction_product_certification.png",
  },
  {
    title:
      "Testing and Inspection Services for Buildings and Construction Materials",
    date: "",
    titleCN: "香港的樓宇及建築材料認可測試和檢驗服務",
    link: "/en/doc/HKCTC_Leaflet_Building_inspection.pdf",
    scLink: "/tc/doc/HKCTC_Leaflet_Building_inspection.pdf",
    tcLink: "/tc/doc/HKCTC_Leaflet_Building_inspection.pdf",
    mediaType: MEDIA_TYPE.PDF,
    category: [CATEGORIES.PUBLICATIONS],
    thumbnail: "HKCTC_Leaflet_Building_inspection.png",
  },
  {
    title: "What you Need to Know about Medical Testing",
    date: "",
    titleCN: "選擇醫務化驗須知",
    link: "/en/quality/hkas/doc/pamphlets/HKAS_PB004.pdf",
    tcLink: "/en/quality/hkas/doc/pamphlets/HKAS_PB004.pdf",
    scLink: "/en/quality/hkas/doc/pamphlets/HKAS_PB004.pdf",
    mediaType: MEDIA_TYPE.PDF,
    category: [CATEGORIES.PUBLICATIONS],
    thumbnail: "HKAS_PB004.png",
  },
  {
    title: "Food Testing and Certification",
    titleCN: "食品檢測和認證",
    date: "",
    link: "/en/doc/Food_Pamphlet_2018.pdf",
    tcLink: "/en/doc/Food_Pamphlet_2018.pdf",
    scLink: "/en/doc/Food_Pamphlet_2018.pdf",
    mediaType: MEDIA_TYPE.PDF,
    category: [CATEGORIES.PUBLICATIONS],
    thumbnail: "Food_Pamphlet_2018.png",
  },
  {
    title: "Chinese Medicines Testing",
    titleCN: "中藥測試",
    date: "",
    link: "/en/doc/Chinese_Medicines_Pamphlet_2018.pdf",
    mediaType: MEDIA_TYPE.PDF,
    category: [CATEGORIES.PUBLICATIONS],
    thumbnail: "Chinese_Medicines_Pamphlet_2018.png",
  },
  {
    title: "Testing of Fei Cui and Diamond in Hong Kong",
    titleCN: "香港翡翠及鑽石測試",
    date: "",
    link: "/en/doc/Testing_of_Fei_Cui_and_Diamond_in_Hong_Kong.pdf",
    mediaType: MEDIA_TYPE.PDF,
    category: [CATEGORIES.PUBLICATIONS],
    thumbnail: "Testing_of_Fei_Cui_and_Diamond_in_Hong_Kong.png",
  },
  {
    title: "Diamond Testing Services in Hong Kong",
    titleCN: "香港的鑽石測試服務",
    date: "",
    link: "/en/doc/HKCTC_Diamond_Testing_Services_in_HK.pdf",
    mediaType: MEDIA_TYPE.PDF,
    category: [CATEGORIES.PUBLICATIONS],
    thumbnail: "HKCTC_Diamond_Testing_Services_in_HK.png",
  },
  {
    title:
      "Understanding Information Security Management System (ISMS) Certification",
    date: "",
    titleCN: "認識資訊安全管理系統認證",
    link: "/en/doc/ISMS_Flyer_Communications_5.pdf",
    mediaType: MEDIA_TYPE.PDF,
    category: [CATEGORIES.PUBLICATIONS],
    thumbnail: "ISMS_Flyer_Communications_5.png",
  },
  {
    title: "Greenhouse Gas (GHG) Quantification, Validation and Verification",
    date: "",
    titleCN: "溫室氣體量化、審定和核查",
    link: "/en/doc/2017_ITC_Leaflet_ISO14064.pdf",
    mediaType: MEDIA_TYPE.PDF,
    category: [CATEGORIES.PUBLICATIONS],
    thumbnail: "2017_ITC_Leaflet_ISO14064.png",
  },
  {
    title: "ISO 50001 Energy Management System Certification",
    date: "",
    titleCN: "ISO 50001能源管理體系認證",
    link: "/en/doc/2017_ITC_Leaflet_ISO50001.pdf",
    mediaType: MEDIA_TYPE.PDF,
    category: [CATEGORIES.PUBLICATIONS],
    thumbnail: "2017_ITC_Leaflet_ISO50001.png",
  },
  {
    title: "Career Development in Testing and Certification Industry",
    date: "",
    titleCN: "檢測認證職業發展",
    link: "/en/doc/pamphlet_a.pdf",
    mediaType: MEDIA_TYPE.PDF,
    category: [CATEGORIES.PUBLICATIONS],
    thumbnail: "pamphlet_a.png",
  },
];

export const bookletsList: PublicationType[] = [
  {
    title: "Electrical and Electronic Products",
    date: "",
    titleCN: "電氣及電子產品",
    link: "/en/doc/EEP_booklet_eng.pdf",
    scLink: "/sc/doc/EEP_booklet_sc.pdf",
    tcLink: "/tc/doc/EEP_booklet_tc.pdf",
    mediaType: MEDIA_TYPE.PDF,
    category: [CATEGORIES.PUBLICATIONS],
  },
  {
    title: "Textile and Apparel",
    date: "",
    titleCN: "紡織與成衣",
    link: "/en/doc/textile_booklet_low_res_eng.pdf",
    scLink: "/sc/doc/textile_booklet_low_res_schi.pdf",
    tcLink: "/tc/doc/textile_booklet_low_res_chi.pdf",
    mediaType: MEDIA_TYPE.PDF,
    category: [CATEGORIES.PUBLICATIONS],
  },
  {
    title: "Toys",
    titleCN: "玩具",
    date: "",
    link: "/en/doc/toys_booklet_eng.pdf",
    scLink: "/sc/doc/toys_booklet_sc.pdf",
    tcLink: "/tc/doc/toys_booklet_tc.pdf",
    mediaType: MEDIA_TYPE.PDF,
    category: [CATEGORIES.PUBLICATIONS],
  },
  {
    title: "Food",
    date: "",
    titleCN: "食品",
    link: "/en/doc/food_booklet_eng.pdf",
    scLink: "/tc/doc/brochure_c.pdf",
    tcLink: "/tc/doc/brochure_c.pdf",
    mediaType: MEDIA_TYPE.PDF,
    category: [CATEGORIES.PUBLICATIONS],
  },
  {
    title: "Testing and Certification Create Your Future",
    date: "",
    titleCN: "檢測認證創未來",
    link: "/en/doc/brochure_e.pdf",
    mediaType: MEDIA_TYPE.PDF,
    category: [CATEGORIES.PUBLICATIONS],
  },
];

export const booletsList_cn: PublicationType[] = bookletsList.map((b) => {
  return {
    title: b.titleCN as string,
    date: b.date,
    link: b.link,
    scLink: b?.scLink,
    tcLink: b?.tcLink,
    mediaType: b.mediaType,
    category: [CATEGORIES.PUBLICATIONS],
  };
});

export const comicsList: PublicationType[] = [
  {
    title: "第一話 : 講個「信」字？",
    link: "/tc/doc/comic_issue_no_1.pdf",
    mediaType: MEDIA_TYPE.PDF,
    category: [CATEGORIES.PUBLICATIONS],
    thumbnail: "publications/comics/comics_1.png",
  },
  {
    title: "第二話：我要 check 清楚",
    link: "/tc/doc/comic_issue_no_2.pdf",
    mediaType: MEDIA_TYPE.PDF,
    category: [CATEGORIES.PUBLICATIONS],
    thumbnail: "publications/comics/comics_2.png",
  },
  {
    title: "第三話：抗菌防臭襪",
    link: "/tc/doc/comic_issue_no_3.pdf",
    mediaType: MEDIA_TYPE.PDF,
    category: [CATEGORIES.PUBLICATIONS],
    thumbnail: "publications/comics/comics_3.png",
  },
  {
    title: "第四話：生日禮物",
    link: "/tc/doc/comic_issue_no_4.pdf",
    mediaType: MEDIA_TYPE.PDF,
    category: [CATEGORIES.PUBLICATIONS],
    thumbnail: "publications/comics/comics_4.png",
  },
  {
    title: "第五話：壓力煲風雲",
    link: "/tc/doc/comic_issue_no_5.pdf",
    mediaType: MEDIA_TYPE.PDF,
    category: [CATEGORIES.PUBLICATIONS],
    thumbnail: "publications/comics/comics_5.png",
  },
  {
    title: "第六話：能源效益測試",
    link: "/tc/doc/comic_issue_no_6.pdf",
    mediaType: MEDIA_TYPE.PDF,
    category: [CATEGORIES.PUBLICATIONS],
    thumbnail: "publications/comics/comics_6.png",
  },
  {
    title: "第七話：神奇縮水毛衣",
    link: "/tc/doc/comic_issue_no_7.pdf",
    mediaType: MEDIA_TYPE.PDF,
    category: [CATEGORIES.PUBLICATIONS],
    thumbnail: "publications/comics/comics_7.png",
  },
  {
    title: "第八話：我很大方",
    link: "/tc/doc/comic_issue_no_8.pdf",
    mediaType: MEDIA_TYPE.PDF,
    category: [CATEGORIES.PUBLICATIONS],
    thumbnail: "publications/comics/comics_8.png",
  },
  {
    title: "第九話：明明都是碟",
    link: "/tc/doc/comic_issue_no_9.pdf",
    mediaType: MEDIA_TYPE.PDF,
    category: [CATEGORIES.PUBLICATIONS],
    thumbnail: "publications/comics/comics_9.png",
  },
  {
    title: "第十話：手機干擾",
    link: "/tc/doc/comic_issue_no_10.pdf",
    mediaType: MEDIA_TYPE.PDF,
    category: [CATEGORIES.PUBLICATIONS],
    thumbnail: "publications/comics/comics_10.png",
  },
  {
    title: "第十一話：愈深愈擋光？",
    link: "/tc/doc/comic_issue_no_11.pdf",
    mediaType: MEDIA_TYPE.PDF,
    category: [CATEGORIES.PUBLICATIONS],
    thumbnail: "publications/comics/comics_11.png",
  },
  {
    title: "第十二話：個磅呃秤？",
    link: "/tc/doc/comic_issue_no_12.pdf",
    mediaType: MEDIA_TYPE.PDF,
    category: [CATEGORIES.PUBLICATIONS],
    thumbnail: "publications/comics/comics_12.png",
  },
  {
    title: "第十三話：另類測試",
    link: "/tc/doc/comic_issue_no_13.pdf",
    mediaType: MEDIA_TYPE.PDF,
    category: [CATEGORIES.PUBLICATIONS],
    thumbnail: "publications/comics/comics_13.png",
  },
  {
    title: "第十四話：有機大計",
    link: "/tc/doc/comic_issue_no_14.pdf",
    mediaType: MEDIA_TYPE.PDF,
    category: [CATEGORIES.PUBLICATIONS],
    thumbnail: "publications/comics/comics_14.png",
  },
  {
    title: "第十五話：紅唇烈焰",
    link: "/tc/doc/comic_issue_no_15.pdf",
    mediaType: MEDIA_TYPE.PDF,
    category: [CATEGORIES.PUBLICATIONS],
    thumbnail: "publications/comics/comics_15.png",
  },
  {
    title: "第十六話：新裝潢新味道",
    link: "/tc/doc/comic_issue_no_16.pdf",
    mediaType: MEDIA_TYPE.PDF,
    category: [CATEGORIES.PUBLICATIONS],
    thumbnail: "publications/comics/comics_16.png",
  },
  {
    title: "第十七話：可愛動物裝",
    link: "/tc/doc/comic_issue_no_17.pdf",
    mediaType: MEDIA_TYPE.PDF,
    category: [CATEGORIES.PUBLICATIONS],
    thumbnail: "publications/comics/comics_17.png",
  },
  {
    title: "第十八話：爸爸忙什麼",
    link: "/tc/doc/comic_issue_no_18.pdf",
    mediaType: MEDIA_TYPE.PDF,
    category: [CATEGORIES.PUBLICATIONS],
    thumbnail: "publications/comics/comics_18.png",
  },
  {
    title: "第十九話：超軟床褥",
    link: "/tc/doc/comic_issue_no_19.pdf",
    mediaType: MEDIA_TYPE.PDF,
    category: [CATEGORIES.PUBLICATIONS],
    thumbnail: "publications/comics/comics_19.png",
  },
  {
    title: "第二十話：試造新衫",
    link: "/tc/doc/comic_issue_no_20.pdf",
    mediaType: MEDIA_TYPE.PDF,
    category: [CATEGORIES.PUBLICATIONS],
    thumbnail: "publications/comics/comics_20.png",
  },
  {
    title: "第二十一話：返工就打噴嚏？",
    link: "/tc/doc/comic_issue_no_21.pdf",
    mediaType: MEDIA_TYPE.PDF,
    category: [CATEGORIES.PUBLICATIONS],
    thumbnail: "publications/comics/comics_21.png",
  },
  {
    title: "第二十二話：自製冰袋",
    link: "/tc/doc/comic_issue_no_22.pdf",
    mediaType: MEDIA_TYPE.PDF,
    category: [CATEGORIES.PUBLICATIONS],
    thumbnail: "publications/comics/comics_22.png",
  },
  {
    title: "第二十三話：遙控機械人",
    link: "/tc/doc/comic_issue_no_23.pdf",
    mediaType: MEDIA_TYPE.PDF,
    category: [CATEGORIES.PUBLICATIONS],
    thumbnail: "publications/comics/comics_23.png",
  },
  {
    title: "第二十四話：鑽的疑惑",
    link: "/tc/doc/comic_issue_no_24.pdf",
    mediaType: MEDIA_TYPE.PDF,
    category: [CATEGORIES.PUBLICATIONS],
    thumbnail: "publications/comics/comics_24.png",
  },
  {
    title: "第二十五話：香味專家",
    link: "/tc/doc/comic_issue_no_25.pdf",
    mediaType: MEDIA_TYPE.PDF,
    category: [CATEGORIES.PUBLICATIONS],
    thumbnail: "publications/comics/comics_25.png",
  },
  {
    title: "第二十六話：各有所好",
    link: "/tc/doc/comic_issue_no_26.pdf",
    mediaType: MEDIA_TYPE.PDF,
    category: [CATEGORIES.PUBLICATIONS],
    thumbnail: "publications/comics/comics_26.png",
  },
  {
    title: "第二十七話：試食曲奇",
    link: "/tc/doc/comic_issue_no_27.pdf",
    mediaType: MEDIA_TYPE.PDF,
    category: [CATEGORIES.PUBLICATIONS],
    thumbnail: "publications/comics/comics_27.png",
  },
  {
    title: "第二十八話：奪命喊聲",
    link: "/tc/doc/comic_issue_no_28.pdf",
    mediaType: MEDIA_TYPE.PDF,
    category: [CATEGORIES.PUBLICATIONS],
    thumbnail: "publications/comics/comics_28.png",
  },
  {
    title: "第二十九話：深宵驚魂",
    link: "/tc/doc/comic_issue_no_29.pdf",
    mediaType: MEDIA_TYPE.PDF,
    category: [CATEGORIES.PUBLICATIONS],
    thumbnail: "publications/comics/comics_29.png",
  },
  {
    title: "第三十話：學生模範",
    link: "/tc/doc/comic_issue_no_30.pdf",
    mediaType: MEDIA_TYPE.PDF,
    category: [CATEGORIES.PUBLICATIONS],
    thumbnail: "publications/comics/comics_30.png",
  },
];

export const corruptionGuideList: PublicationType[] = [
  {
    title: "Corruption Prevention Guide for Testing and Certification Industry",
    titleCN: "檢測和認證業防貪指引",
    link: "/UPloadImages/InfoFile/cate_43/2016/f0cf22b8-ca79-403e-9682-16b6a2166abe.pdf",
    tcLink:
      "/UPloadImages/InfoFile/cate_43/2016/4a4183e9-f029-46c1-92c1-8a7c1d97b119.pdf",
    scLink:
      "/UPloadImages/InfoFile/cate_43/2016/4a4183e9-f029-46c1-92c1-8a7c1d97b119.pdf",
    mediaType: MEDIA_TYPE.PDF,
    category: [CATEGORIES.PUBLICATIONS],
    mediaDomain: "cpas-icac",
    thumbnail: "pamphlets/f0cf22b8-ca79-403e-9682-16b6a2166abe.png",
  },
  {
    title:
      "Pamphlet for Frontline Materials Testing Staff (Chinese Version Only)",
    titleCN: "物料檢測人員防貪小貼士",
    link: "/Upload/guides/57/pdf/68a7ed5f2da24f17930d7bbb8c66a8ca.pdf", // https://www.hkbedc.icac.hk
    mediaType: MEDIA_TYPE.PDF,
    category: [CATEGORIES.PUBLICATIONS],
    mediaDomain: "hkbedc",
    thumbnail: "pamphlets/68a7ed5f2da24f17930d7bbb8c66a8ca.png",
  },
];

export const corruptionGuideList_cn: PublicationType[] =
  corruptionGuideList.map((b) => {
    return {
      title: b.titleCN as string,
      date: b.date,
      link: b.link,
      mediaType: b.mediaType,
      category: [CATEGORIES.PUBLICATIONS],
      tcLink: b?.tcLink,
      scLink: b?.scLink,
    };
  });

export const otherInformationList: PublicationType[] = [
  {
    title: "Hong Kong: The Facts - Testing and Certification",
    titleCN: "香港便覽–檢測和認證",
    link: "/en/doc/Testing_and_Certification_EN.pdf",
    tcLink: "/tc/doc/Testing_and_Certification_TC.pdf",
    scLink: "/sc/doc/Testing_and_Certification_SC.pdf",
    mediaType: MEDIA_TYPE.PDF,
    category: [CATEGORIES.PUBLICATIONS],
  },
];

export const otherInformationList_cn: PublicationType[] =
  otherInformationList.map((b) => {
    return {
      title: b.titleCN as string,
      date: b.date,
      link: b.link,
      mediaType: b.mediaType,
      tcLink: b?.tcLink,
      scLink: b?.scLink,
      category: [CATEGORIES.PUBLICATIONS],
    };
  });

export const advertorialsList: PublicationType[] = [
  {
    title: "23 May 2025",
    date: "",
    link: "/en/doc/20250523-Recruit.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MANPOWER],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2025, 2025],
  },
  {
    title: "25 Apr 2025",
    date: "",
    link: "/en/doc/20250425-Recruit.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MANPOWER],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2025, 2025],
  },
  {
    title: "25 Mar 2022",
    date: "",
    link: "/en/doc/20220325-SkyPost-Promotion_of_Professionalism_of_TC_Practitioners.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.OVERVIEW],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2022, 2022],
  },
  {
    title: "28 Feb 2022",
    date: "",
    link: "/en/doc/20220228-Professionalism_of_TC_Practitioners.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.OVERVIEW],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2022, 2022],
  },
  {
    title: "13 Mar 2018",
    date: "",
    link: "/en/doc/20180313_AM730_Supply_Chain.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.OVERVIEW],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2018, 2018],
  },
  {
    title: "27 Jul 2017",
    date: "",
    link: "/en/doc/20170727-SCMP-Overview_of_T&C_Industry.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.OVERVIEW],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2017, 2017],
  },
  {
    title: "27 Jul 2017",
    date: "",
    link: "/en/doc/20170727-Sing_Tao-Overview_of_T&C_Industry.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.OVERVIEW],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2017, 2017],
  },
  {
    title: "8 Mar 2017",
    date: "",
    link: "/en/doc/20170308-Ming_Pao_Consumer_Product_Testing.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.OVERVIEW],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2017, 2017],
  },
  {
    title: "22 Dec 2016",
    date: "",
    link: "/en/doc/20161222-Headline_Daily-Consumer_Council.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.OVERVIEW],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2016, 2016],
  },
  {
    title: "22 Dec 2016",
    date: "",
    link: "/en/doc/20161222-Oriental_Daily-Consumer_Council.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.OVERVIEW],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2016, 2016],
  },
  {
    title: "16 Dec 2016",
    date: "",
    link: "/en/doc/20161216-HKET-Trade_Description_Ordinance.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.OVERVIEW],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2016, 2016],
  },
  {
    title: "12 Jul 2016",
    date: "",
    link: "/en/doc/20160712-Singtao-Outlook_of_T&C.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.OVERVIEW],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2016, 2016],
  },
  {
    title: "24 Apr 2018",
    date: "",
    link: "/en/doc/20180424_China_Daily_CEPA_Seminar.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MAINLAND_OPPORTUNITY],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2018, 2018],
  },
  {
    title: "18 Apr 2018",
    date: "",
    link: "/en/doc/20180418_HKET_CEPA_Seminar.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MAINLAND_OPPORTUNITY],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2018, 2018],
  },
  {
    title: "20 Jun 2017",
    date: "",
    link: "/en/doc/20170620-China_Daily-Mainland_Opp.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MAINLAND_OPPORTUNITY],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2017, 2017],
  },
  {
    title: "16 Jun 2017",
    date: "",
    link: "/en/doc/20170616-HKET-Mainland_Opp.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MAINLAND_OPPORTUNITY],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2017, 2017],
  },
  {
    title: "8 Mar 2017",
    date: "",
    link: "/en/doc/20170308-Ming_Pao_Consumer_Product_Testing.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MAINLAND_OPPORTUNITY],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2017, 2017],
  },
  {
    title: "9 Oct 2024",
    date: "",
    link: "/en/doc/20241009-MingPao-Digi_Sci_video_prod_comp_secondary_2023_24.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MANPOWER],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2024, 2024],
  },
  {
    title: "7 Oct 2024",
    date: "",
    link: "/en/doc/20241007-YoungPost-Digi_Sci_video_prod_comp_secondary_2023_24.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MANPOWER],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2024, 2024],
  },
  {
    title: "21 Jun 2024",
    date: "",
    link: "/en/doc/240621_recruit_magazine.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MANPOWER],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2024, 2024],
  },
  {
    title: "23 May 2024",
    date: "",
    link: "/en/doc/20240523-SingTao-HKCTC_Special_Award.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MANPOWER],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2024, 2024],
  },
  {
    title: "20 May 2024",
    date: "",
    link: "/en/doc/20240520-Young_post-HKCTC_Special_Award.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MANPOWER],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2024, 2024],
  },
  {
    title: "8 Dec 2023",
    date: "",
    link: "/en/doc/20231208-HKET-ceremony_tcmpaward_2023-24.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MANPOWER],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2023, 2023],
  },
  {
    title: "6 Aug 2023",
    date: "",
    link: "/en/doc/202307-YP-Digi_Science.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MANPOWER],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2023, 2023],
  },
  {
    title: "27 Jul 2023",
    date: "",
    link: "/en/doc/20230727-SingTao-Digi_Science_Video_Production_Competition.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MANPOWER],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2023, 2023],
  },
  {
    title: "19 Jun 2023",
    date: "",
    link: "/en/doc/20230619-YP-HKCTC_Special_Award.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MANPOWER],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2023, 2023],
  },
  {
    title: "15 Jun 2023",
    date: "",
    link: "/en/doc/20230615-Ming_Pao-Advertorial_on_HKCTC_Award.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MANPOWER],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2023, 2023],
  },
  {
    title: "17 Oct 2022",
    date: "",
    link: "/en/doc/20221017-Young_Post-Digi-Science_2022.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MANPOWER],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2022, 2022],
  },
  {
    title: "13 Oct 2022",
    date: "",
    link: "/en/doc/20221013-Digi_Sciece_Video_Production_Competition_22_MP.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MANPOWER],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2022, 2022],
  },
  {
    title: "10 Oct 2022",
    date: "",
    link: "/en/doc/20221010-Young_Post-HKCTC_Special_Award.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MANPOWER],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2022, 2022],
  },
  {
    title: "6 Oct 2022",
    date: "",
    link: "/en/doc/20221006-Sing_Tao-HKCTC_Special_Award.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MANPOWER],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2022, 2022],
  },
  {
    title: "23 Aug 2022",
    date: "",
    link: "/en/doc/20220823-Corporate_Awardees.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MANPOWER],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2022, 2022],
  },
  {
    title: "30 Dec 2021",
    date: "",
    link: "/en/doc/20211230-HKET-TnC_Manpower_Development_Award_Scheme.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MANPOWER],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2021, 2021],
  },
  {
    title: "30 Dec 2021",
    date: "",
    link: "/en/doc/20211230-Headline_Daily-TnC_Manpower_Development_Award_Scheme.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MANPOWER],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2021, 2021],
  },
  {
    title: "30 Nov 2021",
    date: "",
    link: "/en/doc/20211130-Ming_Pao-HK_Youth_Science_and_Technology_Innovation_Competition.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MANPOWER],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2021, 2021],
  },
  {
    title: "15 Nov 2021",
    date: "",
    link: "/en/doc/20211115-Young_Post-HK_Youth_Science_and_Technology_Innovation_Competition.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MANPOWER],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2021, 2021],
  },
  {
    title: "11 Oct 2021",
    date: "",
    link: "/en/doc/20211011_Digi-Science_Video_Production_Competition_Young_Post.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MANPOWER],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2021, 2021],
  },
  {
    title: "29 Sep 2021",
    date: "",
    link: "/en/doc/20210929_Digi-Science_Video_Production_Competition_Sing_Tao.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MANPOWER],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2021, 2021],
  },
  {
    title: "29 Oct 2020",
    date: "",
    link: "/en/doc/20201029_Young_Post_Science_Technology_Competition.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MANPOWER],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2020, 2020],
  },
  {
    title: "15 Oct 2020",
    date: "",
    link: "/en/doc/20201015_Sing_Tao_Young_Post_Science_Technology_Competition.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MANPOWER],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2020, 2020],
  },
  {
    title: "5 Aug 2019",
    date: "",
    link: "/en/doc/20190805_Headline_Daily_Manpower.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MANPOWER],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2019, 2019],
  },
  {
    title: "28 Jun 2019",
    date: "",
    link: "/en/doc/20190628_Student_Competition_Young_Post.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MANPOWER],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2019, 2019],
  },
  {
    title: "20 Jun 2019",
    date: "",
    link: "/en/doc/20190620_Student_Competition_Sing_Tao_Daily.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MANPOWER],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2019, 2019],
  },
  {
    title: "11 Jun 2019",
    date: "",
    link: "/en/doc/20190611_Student_Competition_Ming_Pao.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MANPOWER],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2019, 2019],
  },
  {
    title: "28 Jun 2018",
    date: "",
    link: "/en/doc/20180628_Sing_Tao_Student_Competition.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MANPOWER],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2018, 2018],
  },
  {
    title: "28 Jun 2018",
    date: "",
    link: "/en/doc/20180628_Ming_Pao_Student_Competition.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MANPOWER],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2018, 2018],
  },
  {
    title: "28 Jun 2018",
    date: "",
    link: "/en/doc/20180628_Young_Post_Student_Competition.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MANPOWER],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2018, 2018],
  },
  {
    title: "28 Mar 2018",
    date: "",
    link: "/en/doc/20180328_Ming_Pao_Manpower_Development.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MANPOWER],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2018, 2018],
  },
  {
    title: "29 Jun 2017",
    date: "",
    link: "/en/doc/20170629_Ming_Pao_School_Competition.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MANPOWER],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2017, 2017],
  },
  {
    title: "29 Jun 2017",
    date: "",
    link: "/en/doc/20170629_Young_Post_SCMP_School_Competition.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MANPOWER],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2017, 2017],
  },
  {
    title: "11 May 2017",
    date: "",
    link: "/en/doc/20170511_Sing_Tao_Daily_School_Competition.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MANPOWER],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2017, 2017],
  },
  {
    title: "28 Apr 2017",
    date: "",
    link: "/en/doc/20170428-Ming_Pao-Professional_Development.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MANPOWER],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2017, 2017],
  },
  {
    title: "28 Apr 2017",
    date: "",
    link: "/en/doc/20170428-The_Standard.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MANPOWER],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2017, 2017],
  },
  {
    title: "15 Jun 2016",
    date: "",
    link: "/en/doc/20160615_Oriental_Daily.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MANPOWER],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2016, 2016],
  },
  {
    title: "15 Feb 2016",
    date: "",
    link: "/en/doc/20160215_MingPao_Prof_recognition.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MANPOWER],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2016, 2016],
  },
  {
    title: "30 Jul 2019",
    date: "",
    link: "/en/doc/20190730_HKET_ITC_Advertorial.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.METROLOGY],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2019, 2019],
  },
  {
    title: "30 Jul 2019",
    date: "",
    link: "/en/doc/20190730_The_Standard_WAD.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.METROLOGY],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2019, 2019],
  },
  {
    title: "26 Jul 2018",
    date: "",
    link: "/en/doc/20180726_HKET_HP26Jul.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.METROLOGY],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2018, 2018],
  },
  {
    title: "26 Jul 2018",
    date: "",
    link: "/en/doc/20180726_The_Standard.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.METROLOGY],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2018, 2018],
  },
  {
    title: "3 May 2018",
    date: "",
    link: "/en/doc/20180503_Sing_Tao_Daily_Accreditation.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.METROLOGY],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2018, 2018],
  },
  {
    title: "21 Dec 2017",
    date: "",
    link: "/en/doc/20171221_Sky_Post_Metrology_Symposium.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.METROLOGY],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2017, 2017],
  },
  {
    title: "21 Jul 2017",
    date: "",
    link: "/en/doc/20170721_Ming_Pao_3W_Day.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.METROLOGY],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2017, 2017],
  },
  {
    title: "21 Jul 2017",
    date: "",
    link: "/en/doc/20170721_The_Standard_3W_Day.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.METROLOGY],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2017, 2017],
  },
  {
    title: "5 Aug 2016",
    date: "",
    link: "/en/doc/20160805-Mingpao-3W_Day.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.METROLOGY],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2016, 2016],
  },
  {
    title: "5 Aug 2016",
    date: "",
    link: "/en/doc/20160805-The_Standard.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.METROLOGY],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2016, 2016],
  },
  {
    title: "5 Jan 2018",
    link: "/en/doc/20180105_HKET_Support_to_the_T&C_Industry.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.TC_SUPPORT],
    category: [CATEGORIES.ADVERTORIALS],
    date: "",
    yearRange: [2018, 2018],
  },
  {
    title: "27 Jul 2017",
    link: "/en/doc/20170727-HKET-ITF_Projects.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.TC_SUPPORT],
    category: [CATEGORIES.ADVERTORIALS],
    date: "",
    yearRange: [2017, 2017],
  },
  {
    title: "10 Apr 2019",
    link: "/en/doc/20190410_SCMP_Certification.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.ENVIRONMENT_PROTECTION],
    category: [CATEGORIES.ADVERTORIALS],
    date: "",
    yearRange: [2019, 2019],
  },
  {
    title: "2 Apr 2019",
    link: "/en/doc/20190402_Ming_Pao_Certification.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.ENVIRONMENT_PROTECTION],
    category: [CATEGORIES.ADVERTORIALS],
    date: "",
    yearRange: [2019, 2019],
  },
  {
    title: "May 2018",
    link: "/en/doc/SME_May2018_SF_Testing.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MANAGEMENT_SYSTEM],
    category: [CATEGORIES.ADVERTORIALS],
    date: "",
    yearRange: [2018, 2018],
  },
  {
    title: "10 Apr 2019",
    link: "/en/doc/20190410_SCMP_Certification.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MANAGEMENT_SYSTEM],
    category: [CATEGORIES.ADVERTORIALS],
    date: "",
    yearRange: [2019, 2019],
  },
  {
    title: "2 Apr 2019",
    link: "/en/doc/20190402_Ming_Pao_Certification.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MANAGEMENT_SYSTEM],
    category: [CATEGORIES.ADVERTORIALS],
    date: "",
    yearRange: [2019, 2019],
  },
  {
    title: "31 Mar 2016",
    link: "/en/doc/20160331_AM730_Certification.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MANAGEMENT_SYSTEM],
    category: [CATEGORIES.ADVERTORIALS],
    date: "",
    yearRange: [2016, 2016],
  },
  {
    title: "31 Mar 2016",
    link: "/en/doc/20160331_HKET_Certification.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MANAGEMENT_SYSTEM],
    category: [CATEGORIES.ADVERTORIALS],
    date: "",
    yearRange: [2016, 2016],
  },
  {
    title: "31 Mar 2016",
    link: "/en/doc/20160331_SCMP_Certification.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MANAGEMENT_SYSTEM],
    category: [CATEGORIES.ADVERTORIALS],
    date: "",
    yearRange: [2016, 2016],
  },
  {
    title: "24 Apr 2024",
    link: "/en/doc/20240424_CMM.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.CHINESE_MEDICINE],
    category: [CATEGORIES.ADVERTORIALS],
    date: "",
    yearRange: [2024, 2024],
  },
  {
    title: "13 Apr 2016",
    link: "/en/doc/20160413_Headline_CMM.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.CHINESE_MEDICINE],
    category: [CATEGORIES.ADVERTORIALS],
    date: "",
    yearRange: [2016, 2016],
  },
  {
    title: "27 Mar 2024",
    link: "/en/doc/20240327-advertorial.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.CONSTRUCTION],
    category: [CATEGORIES.ADVERTORIALS],
    date: "",
    yearRange: [2024, 2024],
  },
  {
    title: "23 Jan 2020",
    link: "/en/doc/20200123_Product_Certification_on_Construction_Materials_Economic_Times.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.CONSTRUCTION],
    category: [CATEGORIES.ADVERTORIALS],
    date: "",
    yearRange: [2020, 2020],
  },
  {
    title: "23 Jan 2020",
    link: "/en/doc/20200123_Product_Certification_on_Construction_Materials_SCMP.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.CONSTRUCTION],
    category: [CATEGORIES.ADVERTORIALS],
    date: "",
    yearRange: [2020, 2020],
  },
  {
    title: "25 Jul 2019",
    link: "/en/doc/20190725_Sky_Post_UU_Survey.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.CONSTRUCTION],
    category: [CATEGORIES.ADVERTORIALS],
    date: "",
    yearRange: [2019, 2019],
  },
  {
    title: "18 Dec 2017",
    link: "/en/doc/20171218_ODN_Construction_Materials.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.CONSTRUCTION],
    category: [CATEGORIES.ADVERTORIALS],
    date: "",
    yearRange: [2017, 2017],
  },
  {
    title: "Dec 2017",
    link: "/en/doc/SME_Dec2017_SF_Testing.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.ELECTRICAL_PRODUCTS],
    category: [CATEGORIES.ADVERTORIALS],
    date: "",
    yearRange: [2017, 2017],
  },
  {
    title: "3 Jul 2017",
    link: "/en/doc/20170703-Oriental_Daily-EEP.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.ELECTRICAL_PRODUCTS],
    category: [CATEGORIES.ADVERTORIALS],
    date: "",
    yearRange: [2017, 2017],
  },
  {
    title: "28 May 2024",
    link: "/en/doc/20240528-ESG_Advertorial.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.ENVIRONMENT_PROTECTION],
    category: [CATEGORIES.ADVERTORIALS],
    date: "",
    yearRange: [2024, 2024],
  },
  {
    title: "1 Aug 2019",
    link: "/en/doc/20190801_HKET_Greenhouse_Gas.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.ENVIRONMENT_PROTECTION],
    category: [CATEGORIES.ADVERTORIALS],
    date: "",
    yearRange: [2019, 2019],
  },
  {
    title: "31 Jul 2019",
    link: "/en/doc/20190731_AM730_Testing.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [
      ADVERTORIALS_SECTOR.ENVIRONMENT_PROTECTION,
      ADVERTORIALS_SECTOR.TEXTILE_CLOTHING,
      ADVERTORIALS_SECTOR.TOYS,
    ],
    category: [CATEGORIES.ADVERTORIALS],
    date: "",
    yearRange: [2019, 2019],
  },
  {
    title: "23 Apr 2018",
    link: "/en/doc/20180423_Sing_Tao_Daily_Environmental_Protection.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.ENVIRONMENT_PROTECTION],
    category: [CATEGORIES.ADVERTORIALS],
    date: "",
    yearRange: [2018, 2018],
  },
  {
    title: "10 Apr 2017",
    link: "/en/doc/20170410-Sing_Tao-Environmental_Protection.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.ENVIRONMENT_PROTECTION],
    category: [CATEGORIES.ADVERTORIALS],
    date: "",
    yearRange: [2017, 2017],
  },
  {
    title: "30 Apr 2019",
    link: "/en/doc/20190430_Food.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.FOOD],
    category: [CATEGORIES.ADVERTORIALS],
    date: "",
    yearRange: [2019, 2019],
  },
  {
    title: "28 Jun 2018",
    link: "/en/doc/20180628_Smart_Parents_Food_Certification.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.FOOD],
    category: [CATEGORIES.ADVERTORIALS],
    date: "",
    yearRange: [2018, 2018],
  },
  {
    title: "13 Mar 2018",
    link: "/en/doc/20180313_Headline_Daily_Food_Certification.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.FOOD],
    category: [CATEGORIES.ADVERTORIALS],
    date: "",
    yearRange: [2018, 2018],
  },
  {
    title: "11 Jul 2018",
    link: "/en/doc/20180711_Headline_Daily_ISO27001.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.INFORMATION_TECHNOLOGY],
    category: [CATEGORIES.ADVERTORIALS],
    date: "",
    yearRange: [2018, 2018],
  },
  {
    title: "30 Aug 2017",
    link: "/en/doc/20170830_AM730_ISO27001.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.INFORMATION_TECHNOLOGY],
    category: [CATEGORIES.ADVERTORIALS],
    date: "",
    yearRange: [2017, 2017],
  },
  {
    title: "29 Aug 2017",
    link: "/en/doc/20170829_HKEJ_ISO27001.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.INFORMATION_TECHNOLOGY],
    category: [CATEGORIES.ADVERTORIALS],
    date: "",
    yearRange: [2017, 2017],
  },
  {
    title: "26 Jan 2017",
    link: "/en/doc/20170126-HKET-ICT_ISO27001.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.INFORMATION_TECHNOLOGY],
    category: [CATEGORIES.ADVERTORIALS],
    date: "",
    yearRange: [2017, 2017],
  },
  {
    title: "26 Apr 2018",
    link: "/en/doc/20180426_HKET_Jewellery_Seminar.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.JEWELLERY],
    category: [CATEGORIES.ADVERTORIALS],
    date: "",
    yearRange: [2018, 2018],
  },
  {
    title: "May 2017",
    link: "/en/doc/SME_May2017_SF_Testing.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.JEWELLERY],
    category: [CATEGORIES.ADVERTORIALS],
    date: "",
    yearRange: [2017, 2017],
  },
  {
    title: "16 Dec 2016",
    link: "/en/doc/20161216-HKET-Trade_Description_Ordinance.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.JEWELLERY],
    category: [CATEGORIES.ADVERTORIALS],
    date: "",
    yearRange: [2016, 2016],
  },
  {
    title: "18 Nov 2016",
    link: "/en/doc/20161118-Ming_Pao-Jewellery_Seminar.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.JEWELLERY],
    category: [CATEGORIES.ADVERTORIALS],
    date: "",
    yearRange: [2016, 2016],
  },
  {
    title: "20 Apr 2023",
    link: "/en/doc/20230420-Advertorial_on_Medical_Laboratory.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MEDICAL_TESTING],
    category: [CATEGORIES.ADVERTORIALS],
    date: "",
    yearRange: [2023, 2023],
  },
  {
    title: "Apr 2021",
    link: "/en/doc/202104_Medical_Laboratory_Accreditation_Health_Action.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MEDICAL_TESTING],
    category: [CATEGORIES.ADVERTORIALS],
    date: "",
    yearRange: [2021, 2021],
  },
  {
    title: "Mar 2021",
    link: "/en/doc/202103_Medical_Laboratory_Accreditation_Health_Plus.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MEDICAL_TESTING],
    category: [CATEGORIES.ADVERTORIALS],
    date: "",
    yearRange: [2021, 2021],
  },
  {
    title: "4 Oct 2018",
    link: "/en/doc/20181004_Sing_Tao_Medical_Lab_Accreditation.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MEDICAL_TESTING],
    category: [CATEGORIES.ADVERTORIALS],
    date: "",
    yearRange: [2018, 2018],
  },
  {
    title: "May 2018",
    link: "/en/doc/Medical_May2018_SF_Testing.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MEDICAL_TESTING],
    category: [CATEGORIES.ADVERTORIALS],
    date: "",
    yearRange: [2018, 2018],
  },
  {
    title: "30 Sep 2016",
    link: "/en/doc/20160930-Headline-medical_testing.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MEDICAL_TESTING],
    category: [CATEGORIES.ADVERTORIALS],
    date: "",
    yearRange: [2016, 2016],
  },
  {
    title: "15 Dec 2017",
    link: "/en/doc/20171215_ODN_Textile_and_Garment.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.TEXTILE_CLOTHING],
    category: [CATEGORIES.ADVERTORIALS],
    date: "",
    yearRange: [2017, 2017],
  },
  {
    title: "Dec 2016",
    link: "/en/doc/SME_Dec2016_SF_Testing.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.TEXTILE_CLOTHING],
    category: [CATEGORIES.ADVERTORIALS],
    date: "",
    yearRange: [2016, 2016],
  },

  {
    title: "9 Jan 2017",
    link: "/en/doc/20170109-Oriental_Daily-Toy_Testing.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.TOYS],
    category: [CATEGORIES.ADVERTORIALS],
    date: "",
    yearRange: [2017, 2017],
  },
  {
    title: "May 2016",
    link: "/en/doc/SME_May2016_SF_Testing.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.TOYS],
    category: [CATEGORIES.ADVERTORIALS],
    date: "",
    yearRange: [2016, 2016],
  },
  {
    title: "14 Apr 2016",
    date: "",
    link: "/en/doc/20160414_Mingpao_Toys.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.TOYS],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2016, 2016],
  },
];

export const advertorialsList_cn = [
  {
    title: "2022年3月25日",
    date: "",
    link: "/en/doc/20220325-SkyPost-Promotion_of_Professionalism_of_TC_Practitioners.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.OVERVIEW],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2022, 2022],
  },
  {
    title: "2022年2月28日",
    date: "",
    link: "/en/doc/20220228-Professionalism_of_TC_Practitioners.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.OVERVIEW],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2022, 2022],
  },
  {
    title: "2018年3月13日",
    date: "",
    link: "/en/doc/20180313_AM730_Supply_Chain.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.OVERVIEW],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2018, 2018],
  },
  {
    title: "2017年7月27日",
    date: "",
    link: "/en/doc/20170727-SCMP-Overview_of_T&C_Industry.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.OVERVIEW],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2017, 2017],
  },
  {
    title: "2017年7月27日",
    date: "",
    link: "/en/doc/20170727-Sing_Tao-Overview_of_T&C_Industry.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.OVERVIEW],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2017, 2017],
  },
  {
    title: "2017年3月8日",
    date: "",
    link: "/en/doc/20170308-Ming_Pao_Consumer_Product_Testing.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.OVERVIEW],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2017, 2017],
  },
  {
    title: "2016年12月22日",
    date: "",
    link: "/en/doc/20161222-Headline_Daily-Consumer_Council.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.OVERVIEW],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2016, 2016],
  },
  {
    title: "2016年12月22日",
    date: "",
    link: "/en/doc/20161222-Oriental_Daily-Consumer_Council.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.OVERVIEW],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2016, 2016],
  },
  {
    title: "2016年12月16日",
    date: "",
    link: "/en/doc/20161216-HKET-Trade_Description_Ordinance.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.OVERVIEW],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2016, 2016],
  },
  {
    title: "2016年7月12日",
    date: "",
    link: "/en/doc/20160712-Singtao-Outlook_of_T&C.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.OVERVIEW],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2016, 2016],
  },
  {
    title: "2018年4月24日",
    date: "",
    link: "/en/doc/20180424_China_Daily_CEPA_Seminar.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MAINLAND_OPPORTUNITY],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2018, 2018],
  },
  {
    title: "2018年4月18日",
    date: "",
    link: "/en/doc/20180418_HKET_CEPA_Seminar.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MAINLAND_OPPORTUNITY],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2018, 2018],
  },
  {
    title: "2017年6月20日",
    date: "",
    link: "/en/doc/20170620-China_Daily-Mainland_Opp.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MAINLAND_OPPORTUNITY],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2017, 2017],
  },
  {
    title: "2017年6月16日",
    date: "",
    link: "/en/doc/20170616-HKET-Mainland_Opp.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MAINLAND_OPPORTUNITY],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2017, 2017],
  },
  {
    title: "2017年3月8日",
    date: "",
    link: "/en/doc/20170308-Ming_Pao_Consumer_Product_Testing.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MAINLAND_OPPORTUNITY],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2017, 2017],
  },
  {
    title: "2024年10月9日",
    date: "",
    link: "/en/doc/20241009-MingPao-Digi_Sci_video_prod_comp_secondary_2023_24.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MANPOWER],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2024, 2024],
  },
  {
    title: "2024年10月7日",
    date: "",
    link: "/en/doc/20241007-YoungPost-Digi_Sci_video_prod_comp_secondary_2023_24.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MANPOWER],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2024, 2024],
  },
  {
    title: "2024年6月21日",
    date: "",
    link: "/en/doc/240621_recruit_magazine.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MANPOWER],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2024, 2024],
  },
  {
    title: "2024年5月23日",
    date: "",
    link: "/en/doc/20240523-SingTao-HKCTC_Special_Award.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MANPOWER],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2024, 2024],
  },
  {
    title: "2024年5月20日",
    date: "",
    link: "/en/doc/20240520-Young_post-HKCTC_Special_Award.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MANPOWER],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2024, 2024],
  },
  {
    title: "2023年12月8日",
    date: "",
    link: "/en/doc/20231208-HKET-ceremony_tcmpaward_2023-24.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MANPOWER],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2023, 2023],
  },
  {
    title: "2023年8月6日",
    date: "",
    link: "/en/doc/202307-YP-Digi_Science.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MANPOWER],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2023, 2023],
  },
  {
    title: "2023年7月27日",
    date: "",
    link: "/en/doc/20230727-SingTao-Digi_Science_Video_Production_Competition.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MANPOWER],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2023, 2023],
  },
  {
    title: "2023年6月19日",
    date: "",
    link: "/en/doc/20230619-YP-HKCTC_Special_Award.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MANPOWER],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2023, 2023],
  },
  {
    title: "2023年6月15日",
    date: "",
    link: "/en/doc/20230615-Ming_Pao-Advertorial_on_HKCTC_Award.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MANPOWER],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2023, 2023],
  },
  {
    title: "2022年10月17日",
    date: "",
    link: "/en/doc/20221017-Young_Post-Digi-Science_2022.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MANPOWER],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2022, 2022],
  },
  {
    title: "2022年10月13日",
    date: "",
    link: "/en/doc/20221013-Digi_Sciece_Video_Production_Competition_22_MP.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MANPOWER],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2022, 2022],
  },
  {
    title: "2022年10月10日",
    date: "",
    link: "/en/doc/20221010-Young_Post-HKCTC_Special_Award.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MANPOWER],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2022, 2022],
  },
  {
    title: "2022年10月6日",
    date: "",
    link: "/en/doc/20221006-Sing_Tao-HKCTC_Special_Award.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MANPOWER],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2022, 2022],
  },
  {
    title: "2022年8月23日",
    date: "",
    link: "/en/doc/20220823-Corporate_Awardees.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MANPOWER],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2022, 2022],
  },
  {
    title: "2021年12月30日",
    date: "",
    link: "/en/doc/20211230-HKET-TnC_Manpower_Development_Award_Scheme.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MANPOWER],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2021, 2021],
  },
  {
    title: "2021年12月30日",
    date: "",
    link: "/en/doc/20211230-Headline_Daily-TnC_Manpower_Development_Award_Scheme.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MANPOWER],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2021, 2021],
  },
  {
    title: "2021年11月30日",
    date: "",
    link: "/en/doc/20211130-Ming_Pao-HK_Youth_Science_and_Technology_Innovation_Competition.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MANPOWER],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2021, 2021],
  },
  {
    title: "2021年11月15日",
    date: "",
    link: "/en/doc/20211115-Young_Post-HK_Youth_Science_and_Technology_Innovation_Competition.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MANPOWER],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2021, 2021],
  },
  {
    title: "2021年10月11日",
    date: "",
    link: "/en/doc/20211011_Digi-Science_Video_Production_Competition_Young_Post.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MANPOWER],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2021, 2021],
  },
  {
    title: "2021年9月29日",
    date: "",
    link: "/en/doc/20210929_Digi-Science_Video_Production_Competition_Sing_Tao.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MANPOWER],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2021, 2021],
  },
  {
    title: "2020年10月29日",
    date: "",
    link: "/en/doc/20201029_Young_Post_Science_Technology_Competition.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MANPOWER],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2020, 2020],
  },
  {
    title: "2020年10月15日",
    date: "",
    link: "/en/doc/20201015_Sing_Tao_Young_Post_Science_Technology_Competition.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MANPOWER],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2020, 2020],
  },
  {
    title: "2019年8月5日",
    date: "",
    link: "/en/doc/20190805_Headline_Daily_Manpower.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MANPOWER],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2019, 2019],
  },
  {
    title: "2019年6月28日",
    date: "",
    link: "/en/doc/20190628_Student_Competition_Young_Post.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MANPOWER],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2019, 2019],
  },
  {
    title: "2019年6月20日",
    date: "",
    link: "/en/doc/20190620_Student_Competition_Sing_Tao_Daily.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MANPOWER],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2019, 2019],
  },
  {
    title: "2019年6月11日",
    date: "",
    link: "/en/doc/20190611_Student_Competition_Ming_Pao.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MANPOWER],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2019, 2019],
  },
  {
    title: "2018年6月28日",
    date: "",
    link: "/en/doc/20180628_Sing_Tao_Student_Competition.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MANPOWER],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2018, 2018],
  },
  {
    title: "2018年6月28日",
    date: "",
    link: "/en/doc/20180628_Ming_Pao_Student_Competition.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MANPOWER],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2018, 2018],
  },
  {
    title: "2018年6月28日",
    date: "",
    link: "/en/doc/20180628_Young_Post_Student_Competition.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MANPOWER],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2018, 2018],
  },
  {
    title: "2018年3月28日",
    date: "",
    link: "/en/doc/20180328_Ming_Pao_Manpower_Development.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MANPOWER],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2018, 2018],
  },
  {
    title: "2017年6月29日",
    date: "",
    link: "/en/doc/20170629_Ming_Pao_School_Competition.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MANPOWER],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2017, 2017],
  },
  {
    title: "2017年6月29日",
    date: "",
    link: "/en/doc/20170629_Young_Post_SCMP_School_Competition.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MANPOWER],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2017, 2017],
  },
  {
    title: "2017年5月11日",
    date: "",
    link: "/en/doc/20170511_Sing_Tao_Daily_School_Competition.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MANPOWER],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2017, 2017],
  },
  {
    title: "2017年4月28日",
    date: "",
    link: "/en/doc/20170428-Ming_Pao-Professional_Development.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MANPOWER],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2017, 2017],
  },
  {
    title: "2017年4月28日",
    date: "",
    link: "/en/doc/20170428-The_Standard.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MANPOWER],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2017, 2017],
  },
  {
    title: "2016年6月15日",
    date: "",
    link: "/en/doc/20160615_Oriental_Daily.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MANPOWER],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2016, 2016],
  },
  {
    title: "2016年2月15日",
    date: "",
    link: "/en/doc/20160215_MingPao_Prof_recognition.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MANPOWER],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2016, 2016],
  },
  {
    title: "2019年7月30日",
    date: "",
    link: "/en/doc/20190730_HKET_ITC_Advertorial.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.METROLOGY],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2019, 2019],
  },
  {
    title: "2019年7月30日",
    date: "",
    link: "/en/doc/20190730_The_Standard_WAD.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.METROLOGY],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2019, 2019],
  },
  {
    title: "2018年7月26日",
    date: "",
    link: "/en/doc/20180726_HKET_HP26Jul.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.METROLOGY],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2018, 2018],
  },
  {
    title: "2018年7月26日",
    date: "",
    link: "/en/doc/20180726_The_Standard.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.METROLOGY],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2018, 2018],
  },
  {
    title: "2018年5月3日",
    date: "",
    link: "/en/doc/20180503_Sing_Tao_Daily_Accreditation.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.METROLOGY],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2018, 2018],
  },
  {
    title: "2017年12月21日",
    date: "",
    link: "/en/doc/20171221_Sky_Post_Metrology_Symposium.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.METROLOGY],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2017, 2017],
  },
  {
    title: "2017年7月21日",
    date: "",
    link: "/en/doc/20170721_Ming_Pao_3W_Day.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.METROLOGY],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2017, 2017],
  },
  {
    title: "2017年7月21日",
    date: "",
    link: "/en/doc/20170721_The_Standard_3W_Day.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.METROLOGY],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2017, 2017],
  },
  {
    title: "2016年8月5日",
    date: "",
    link: "/en/doc/20160805-Mingpao-3W_Day.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.METROLOGY],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2016, 2016],
  },
  {
    title: "2016年8月5日",
    date: "",
    link: "/en/doc/20160805-The_Standard.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.METROLOGY],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2016, 2016],
  },
  {
    title: "2018年1月5日",
    link: "/en/doc/20180105_HKET_Support_to_the_T&C_Industry.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.TC_SUPPORT],
    category: [CATEGORIES.ADVERTORIALS],
    date: "",
    yearRange: [2018, 2018],
  },
  {
    title: "2017年7月27日",
    link: "/en/doc/20170727-HKET-ITF_Projects.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.TC_SUPPORT],
    category: [CATEGORIES.ADVERTORIALS],
    date: "",
    yearRange: [2017, 2017],
  },
  {
    title: "2019年4月10日",
    link: "/en/doc/20190410_SCMP_Certification.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.ENVIRONMENT_PROTECTION],
    category: [CATEGORIES.ADVERTORIALS],
    date: "",
    yearRange: [2019, 2019],
  },
  {
    title: "2019年4月2日",
    link: "/en/doc/20190402_Ming_Pao_Certification.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.ENVIRONMENT_PROTECTION],
    category: [CATEGORIES.ADVERTORIALS],
    date: "",
    yearRange: [2019, 2019],
  },
  {
    title: "2018年5月",
    link: "/en/doc/SME_May2018_SF_Testing.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MANAGEMENT_SYSTEM],
    category: [CATEGORIES.ADVERTORIALS],
    date: "",
    yearRange: [2018, 2018],
  },
  {
    title: "2019年4月10日",
    link: "/en/doc/20190410_SCMP_Certification.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MANAGEMENT_SYSTEM],
    category: [CATEGORIES.ADVERTORIALS],
    date: "",
    yearRange: [2019, 2019],
  },
  {
    title: "2019年4月2日",
    link: "/en/doc/20190402_Ming_Pao_Certification.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MANAGEMENT_SYSTEM],
    category: [CATEGORIES.ADVERTORIALS],
    date: "",
    yearRange: [2019, 2019],
  },
  {
    title: "2016年3月31日",
    link: "/en/doc/20160331_AM730_Certification.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MANAGEMENT_SYSTEM],
    category: [CATEGORIES.ADVERTORIALS],
    date: "",
    yearRange: [2016, 2016],
  },
  {
    title: "2016年3月31日",
    link: "/en/doc/20160331_HKET_Certification.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MANAGEMENT_SYSTEM],
    category: [CATEGORIES.ADVERTORIALS],
    date: "",
    yearRange: [2016, 2016],
  },
  {
    title: "2016年3月31日",
    link: "/en/doc/20160331_SCMP_Certification.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MANAGEMENT_SYSTEM],
    category: [CATEGORIES.ADVERTORIALS],
    date: "",
    yearRange: [2016, 2016],
  },
  {
    title: "2024年4月24日",
    link: "/en/doc/20240424_CMM.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.CHINESE_MEDICINE],
    category: [CATEGORIES.ADVERTORIALS],
    date: "",
    yearRange: [2024, 2024],
  },
  {
    title: "2016年4月13日",
    link: "/en/doc/20160413_Headline_CMM.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.CHINESE_MEDICINE],
    category: [CATEGORIES.ADVERTORIALS],
    date: "",
    yearRange: [2016, 2016],
  },
  {
    title: "2024年3月27日",
    link: "/en/doc/20240327-advertorial.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.CONSTRUCTION],
    category: [CATEGORIES.ADVERTORIALS],
    date: "",
    yearRange: [2024, 2024],
  },
  {
    title: "2020年1月23日",
    link: "/en/doc/20200123_Product_Certification_on_Construction_Materials_Economic_Times.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.CONSTRUCTION],
    category: [CATEGORIES.ADVERTORIALS],
    date: "",
    yearRange: [2020, 2020],
  },
  {
    title: "2020年1月23日",
    link: "/en/doc/20200123_Product_Certification_on_Construction_Materials_SCMP.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.CONSTRUCTION],
    category: [CATEGORIES.ADVERTORIALS],
    date: "",
    yearRange: [2020, 2020],
  },
  {
    title: "2019年7月25日",
    link: "/en/doc/20190725_Sky_Post_UU_Survey.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.CONSTRUCTION],
    category: [CATEGORIES.ADVERTORIALS],
    date: "",
    yearRange: [2019, 2019],
  },
  {
    title: "2017年12月18日",
    link: "/en/doc/20171218_ODN_Construction_Materials.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.CONSTRUCTION],
    category: [CATEGORIES.ADVERTORIALS],
    date: "",
    yearRange: [2017, 2017],
  },
  {
    title: "2017年12月",
    link: "/en/doc/SME_Dec2017_SF_Testing.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.ELECTRICAL_PRODUCTS],
    category: [CATEGORIES.ADVERTORIALS],
    date: "",
    yearRange: [2017, 2017],
  },
  {
    title: "2017年7月3日",
    link: "/en/doc/20170703-Oriental_Daily-EEP.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.ELECTRICAL_PRODUCTS],
    category: [CATEGORIES.ADVERTORIALS],
    date: "",
    yearRange: [2017, 2017],
  },
  {
    title: "2024年5月28日",
    link: "/en/doc/20240528-ESG_Advertorial.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.ENVIRONMENT_PROTECTION],
    category: [CATEGORIES.ADVERTORIALS],
    date: "",
    yearRange: [2024, 2024],
  },
  {
    title: "2019年8月1日",
    link: "/en/doc/20190801_HKET_Greenhouse_Gas.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.ENVIRONMENT_PROTECTION],
    category: [CATEGORIES.ADVERTORIALS],
    date: "",
    yearRange: [2019, 2019],
  },
  {
    title: "2019年7月31日",
    link: "/en/doc/20190731_AM730_Testing.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [
      "ADVERTORIALS_SECTOR.ENVIRONMENT_PROTECTION",
      "ADVERTORIALS_SECTOR.TEXTILE_CLOTHING",
      "ADVERTORIALS_SECTOR.TOYS",
    ],
    category: [CATEGORIES.ADVERTORIALS],
    date: "",
    yearRange: [2019, 2019],
  },
  {
    title: "2018年4月23日",
    link: "/en/doc/20180423_Sing_Tao_Daily_Environmental_Protection.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.ENVIRONMENT_PROTECTION],
    category: [CATEGORIES.ADVERTORIALS],
    date: "",
    yearRange: [2018, 2018],
  },
  {
    title: "2017年4月10日",
    link: "/en/doc/20170410-Sing_Tao-Environmental_Protection.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.ENVIRONMENT_PROTECTION],
    category: [CATEGORIES.ADVERTORIALS],
    date: "",
    yearRange: [2017, 2017],
  },
  {
    title: "2019年4月30日",
    link: "/en/doc/20190430_Food.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.FOOD],
    category: [CATEGORIES.ADVERTORIALS],
    date: "",
    yearRange: [2019, 2019],
  },
  {
    title: "2018年6月28日",
    link: "/en/doc/20180628_Smart_Parents_Food_Certification.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.FOOD],
    category: [CATEGORIES.ADVERTORIALS],
    date: "",
    yearRange: [2018, 2018],
  },
  {
    title: "2018年3月13日",
    link: "/en/doc/20180313_Headline_Daily_Food_Certification.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.FOOD],
    category: [CATEGORIES.ADVERTORIALS],
    date: "",
    yearRange: [2018, 2018],
  },
  {
    title: "2018年7月11日",
    link: "/en/doc/20180711_Headline_Daily_ISO27001.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.INFORMATION_TECHNOLOGY],
    category: [CATEGORIES.ADVERTORIALS],
    date: "",
    yearRange: [2018, 2018],
  },
  {
    title: "2017年8月30日",
    link: "/en/doc/20170830_AM730_ISO27001.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.INFORMATION_TECHNOLOGY],
    category: [CATEGORIES.ADVERTORIALS],
    date: "",
    yearRange: [2017, 2017],
  },
  {
    title: "2017年8月29日",
    link: "/en/doc/20170829_HKEJ_ISO27001.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.INFORMATION_TECHNOLOGY],
    category: [CATEGORIES.ADVERTORIALS],
    date: "",
    yearRange: [2017, 2017],
  },
  {
    title: "2017年1月26日",
    link: "/en/doc/20170126-HKET-ICT_ISO27001.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.INFORMATION_TECHNOLOGY],
    category: [CATEGORIES.ADVERTORIALS],
    date: "",
    yearRange: [2017, 2017],
  },
  {
    title: "2018年4月26日",
    link: "/en/doc/20180426_HKET_Jewellery_Seminar.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.JEWELLERY],
    category: [CATEGORIES.ADVERTORIALS],
    date: "",
    yearRange: [2018, 2018],
  },
  {
    title: "2017年5月",
    link: "/en/doc/SME_May2017_SF_Testing.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.JEWELLERY],
    category: [CATEGORIES.ADVERTORIALS],
    date: "",
    yearRange: [2017, 2017],
  },
  {
    title: "2016年12月16日",
    link: "/en/doc/20161216-HKET-Trade_Description_Ordinance.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.JEWELLERY],
    category: [CATEGORIES.ADVERTORIALS],
    date: "",
    yearRange: [2016, 2016],
  },
  {
    title: "2016年11月18日",
    link: "/en/doc/20161118-Ming_Pao-Jewellery_Seminar.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.JEWELLERY],
    category: [CATEGORIES.ADVERTORIALS],
    date: "",
    yearRange: [2016, 2016],
  },
  {
    title: "2023年4月20日",
    link: "/en/doc/20230420-Advertorial_on_Medical_Laboratory.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MEDICAL_TESTING],
    category: [CATEGORIES.ADVERTORIALS],
    date: "",
    yearRange: [2023, 2023],
  },
  {
    title: "2021年4月",
    link: "/en/doc/202104_Medical_Laboratory_Accreditation_Health_Action.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MEDICAL_TESTING],
    category: [CATEGORIES.ADVERTORIALS],
    date: "",
    yearRange: [2021, 2021],
  },
  {
    title: "2021年3月",
    link: "/en/doc/202103_Medical_Laboratory_Accreditation_Health_Plus.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MEDICAL_TESTING],
    category: [CATEGORIES.ADVERTORIALS],
    date: "",
    yearRange: [2021, 2021],
  },
  {
    title: "2018年10月4日",
    link: "/en/doc/20181004_Sing_Tao_Medical_Lab_Accreditation.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MEDICAL_TESTING],
    category: [CATEGORIES.ADVERTORIALS],
    date: "",
    yearRange: [2018, 2018],
  },
  {
    title: "2018年5月",
    link: "/en/doc/Medical_May2018_SF_Testing.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MEDICAL_TESTING],
    category: [CATEGORIES.ADVERTORIALS],
    date: "",
    yearRange: [2018, 2018],
  },
  {
    title: "2016年9月30日",
    link: "/en/doc/20160930-Headline-medical_testing.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.MEDICAL_TESTING],
    category: [CATEGORIES.ADVERTORIALS],
    date: "",
    yearRange: [2016, 2016],
  },
  {
    title: "2017年12月15日",
    link: "/en/doc/20171215_ODN_Textile_and_Garment.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.TEXTILE_CLOTHING],
    category: [CATEGORIES.ADVERTORIALS],
    date: "",
    yearRange: [2017, 2017],
  },
  {
    title: "2016年12月",
    link: "/en/doc/SME_Dec2016_SF_Testing.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.TEXTILE_CLOTHING],
    category: [CATEGORIES.ADVERTORIALS],
    date: "",
    yearRange: [2016, 2016],
  },
  {
    title: "2017年1月9日",
    link: "/en/doc/20170109-Oriental_Daily-Toy_Testing.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.TOYS],
    category: [CATEGORIES.ADVERTORIALS],
    date: "",
    yearRange: [2017, 2017],
  },
  {
    title: "2016年5月",
    link: "/en/doc/SME_May2016_SF_Testing.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.TOYS],
    category: [CATEGORIES.ADVERTORIALS],
    date: "",
    yearRange: [2016, 2016],
  },
  {
    title: "2016年4月14日",
    date: "",
    link: "/en/doc/20160414_Mingpao_Toys.pdf",
    mediaType: MEDIA_TYPE.PDF,
    sector: [ADVERTORIALS_SECTOR.TOYS],
    category: [CATEGORIES.ADVERTORIALS],
    yearRange: [2016, 2016],
  },
];

export const pamphletsList_cn: PublicationType[] = [
  {
    title: "香港檢測 香港認證",
    date: "",
    link: "/en/doc/Tested_in_Hong_Kong_Certified_in_Hong_Kong_en_tc.pdf",
    mediaType: MEDIA_TYPE.PDF,
    category: [CATEGORIES.PUBLICATIONS],
    thumbnail: "Tested_in_Hong_Kong_Certified_in_Hong_Kong_en_tc.png",
  },
  {
    title: "產品認証 - 從上游監控品質",
    date: "",
    link: "/en/doc/HKCTC_Leaflet_construction_product_certification.pdf",
    mediaType: MEDIA_TYPE.PDF,
    category: [CATEGORIES.PUBLICATIONS],
    thumbnail: "HKCTC_Leaflet_construction_product_certification.png",
  },
  {
    title: "香港的樓宇及建築材料認可測試和檢驗服務",
    date: "",
    link: "/en/doc/HKCTC_Leaflet_Building_inspection.pdf",
    mediaType: MEDIA_TYPE.PDF,
    category: [CATEGORIES.PUBLICATIONS],
    thumbnail: "HKCTC_Leaflet_Building_inspection.png",
  },
  {
    title: "選擇醫務化驗須知",
    date: "",
    link: "/en/quality/hkas/doc/pamphlets/HKAS_PB004.pdf",
    mediaType: MEDIA_TYPE.PDF,
    category: [CATEGORIES.PUBLICATIONS],
    thumbnail: "HKAS_PB004.png",
  },
  {
    title: "食品檢測和認證",
    date: "",
    link: "/en/doc/Food_Pamphlet_2018.pdf",
    mediaType: MEDIA_TYPE.PDF,
    category: [CATEGORIES.PUBLICATIONS],
    thumbnail: "Food_Pamphlet_2018.png",
  },
  {
    title: "中藥測試",
    date: "",
    link: "/en/doc/Chinese_Medicines_Pamphlet_2018.pdf",
    mediaType: MEDIA_TYPE.PDF,
    category: [CATEGORIES.PUBLICATIONS],
    thumbnail: "Chinese_Medicines_Pamphlet_2018.png",
  },
  {
    title: "香港翡翠及鑽石測試",
    date: "",
    link: "/en/doc/Testing_of_Fei_Cui_and_Diamond_in_Hong_Kong.pdf",
    mediaType: MEDIA_TYPE.PDF,
    category: [CATEGORIES.PUBLICATIONS],
    thumbnail: "Testing_of_Fei_Cui_and_Diamond_in_Hong_Kong.png",
  },
  {
    title: "香港的鑽石測試服務",
    date: "",
    link: "/en/doc/HKCTC_Diamond_Testing_Services_in_HK.pdf",
    mediaType: MEDIA_TYPE.PDF,
    category: [CATEGORIES.PUBLICATIONS],
    thumbnail: "HKCTC_Diamond_Testing_Services_in_HK.png",
  },
  {
    title: "認識資訊安全管理系統認證",
    date: "",
    link: "/en/doc/ISMS_Flyer_Communications_5.pdf",
    mediaType: MEDIA_TYPE.PDF,
    category: [CATEGORIES.PUBLICATIONS],
    thumbnail: "ISMS_Flyer_Communications_5.png",
  },
  {
    title: "溫室氣體量化、審定和核查",
    date: "",
    link: "/en/doc/2017_ITC_Leaflet_ISO14064.pdf",
    mediaType: MEDIA_TYPE.PDF,
    category: [CATEGORIES.PUBLICATIONS],
    thumbnail: "2017_ITC_Leaflet_ISO14064.png",
  },
  {
    title: "ISO 50001能源管理體系認證",
    date: "",
    link: "/en/doc/2017_ITC_Leaflet_ISO50001.pdf",
    mediaType: MEDIA_TYPE.PDF,
    category: [CATEGORIES.PUBLICATIONS],
    thumbnail: "2017_ITC_Leaflet_ISO50001.png",
  },
  {
    title: "檢測認證職業發展",
    date: "",
    link: "/en/doc/pamphlet_a.pdf",
    mediaType: MEDIA_TYPE.PDF,
    category: [CATEGORIES.PUBLICATIONS],
    thumbnail: "pamphlet_a.png",
  },
];
